// CSS for this modal is in calendar.css

// INSTRUCTIONS TO LOAD MODAL
// use props
// show modal with setShowMyShiftModal stored in CalendarContext

import React, {
  useEffect,
  useState,
  useContext,
  useReducer,
  useMemo,
  useRef,
} from "react";
// cleaned wef 24 jul 23
// preloaded images 19 sep 23
// axios caught 21 sep 23
// image ready 4 oct 23

import axios from "axios";

import { DataContext } from "../../../contexts/DataContext";
import { CalendarContext } from "../../../contexts/CalendarContext";
import { UserContext } from "../../../contexts/UserContext";

import serverURL from "../../../serverURL";
import { StyleContext } from "../../../contexts/StyleContext";

import dateStringer from "../../../tools/dateStringer";
import horizontalBalls from "../../../img/loaders/horizontalBalls.svg";

import EditMyShiftRequestModal from "./EditMyShiftRequestModal";
import TilTrimModal from "./TilTrimModal";
import CheckUser from "../../../tools/CheckUser";
import profilePicturePlaceholder from "../../../img/general/profilePicturePlaceholder.svg";
import rotaClock2 from "../../../img/general/rotaClock2.svg";

import bin1 from "../../../img/general/bin1.svg";
import swap2 from "../../../img/general/swap2.svg";
import chat from "../../../img/general/chat.svg";
import noteImg from "../../../img/general/noteWhite.svg";
import noteImg2 from "../../../img/general/note.svg";
import edit from "../../../img/general/edit.svg";
import scissors from "../../../img/general/scissors.svg";
import arrGrey from "../../../img/general/arrGrey.svg";
import close from "../../../img/modals/close.svg";
import whitecross from "../../../img/general/whitecross.svg";
import cancelTil from "../../../img/general/cancelTil.svg";
import popup from "../../../img/general/popup2.svg";
import popupX from "../../../img/general/popup.svg";
import greenTick from "../../../img/general/greenTick.svg";
import whiteTick from "../../../img/general/whiteTick.svg";
import doubleTick from "../../../img/general/doubleTick.svg";

import closeGrey from "../../../img/general/closeGrey.svg";
import navySwap from "../../../img/general/navySwap.svg";
import editGrey from "../../../img/general/editGrey.svg";
import greyCross from "../../../img/general/greyCross.svg";
import like from "../../../img/general/like.svg";
import liked from "../../../img/general/liked.svg";
import liked2 from "../../../img/general/liked2.svg";
import acknowledgeArr from "../../../img/general/acknowledgeArr.svg";

// type = til, overtime, shift
const MyShiftModal = ({ unitType, unitID, otherUser }) => {
  let [hoveredLikeCommentID, setHoveredLikeCommentID] = useState("");
  let [showLikedCommentIDs, setShowCommentLikedIDs] = useState([]);

  let [showSelfLogAbsenceModal, setShowSelfLogAbsenceModal] = useState("");

  let [sureCancelAbsence, setSureCancelAbsence] = useState(false);
  let [imagesLoaded, setImagesLoaded] = useState(0);
  let [loading, setLoading] = useState(true);
  let [dataLoaded, setDataLoaded] = useState(false);

  let [showDecline, setShowDecline] = useState(false);
  let [declineReason, setDeclineReason] = useState("");
  let [reason, setReason] = useState("");

  useEffect(() => {
    if (dataLoaded && imagesLoaded === 24) {
      setLoading(false);
    }
  }, [dataLoaded, imagesLoaded]);

  let imgPreload = (
    <div className="imagesHidden">
      {/* Previously added images */}
      {/* ... */}
      {/* Additional images */}
      <img
        src={bin1}
        alt="Bin 1"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />{" "}
      <img
        src={rotaClock2}
        alt="Bin 1"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />{" "}
      <img
        src={doubleTick}
        alt="Bin 1"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />{" "}
      <img
        src={profilePicturePlaceholder}
        alt="Bin 1"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={whiteTick}
        alt="Bin 1"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={swap2}
        alt="Swap 2"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={popupX}
        alt="Swap 2"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={chat}
        alt="Chat"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={noteImg}
        alt="Note White"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={noteImg2}
        alt="Note"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={edit}
        alt="Edit"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={scissors}
        alt="Scissors"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={arrGrey}
        alt="Arrow Grey"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={close}
        alt="Close"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={cancelTil}
        alt="Cancel Til"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={popup}
        alt="Popup 2"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={closeGrey}
        alt="Close Grey"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={navySwap}
        alt="Navy Swap"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={editGrey}
        alt="Edit Grey"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={greyCross}
        alt="Grey Cross"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={like}
        alt="Like"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={liked}
        alt="Liked"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={liked2}
        alt="Liked 2"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
      <img
        src={acknowledgeArr}
        alt="Acknowledge Arr"
        className=""
        onLoad={() => {
          setImagesLoaded(imagesLoaded + 1);
        }}
      />
    </div>
  );

  let [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      itemType: "",
      itemID: "",
      itemTeamID: "",
      itemUserID: "",
      itemDs: "",
      itemStart: "",
      itemEnd: "",
      itemBreak: "",
      itemRate: 1,
      itemCost: 0,
      itemDuration: 0,
      itemNote: [],
      itemAddedBy: "",
      itemTeamName: "",
      itemTags: [],
      itemAddedByUserID: "",
      itemAbsenceData: {},
      itemIsAbsent: false,
      absenceName: "",
      ghost: false,
      takeTilRequestMade: false,
      takeTilRequest: false,
      tilStart: "",
      tilEnd: "",
      tilMins: 0,
      tilRequested: false,
      tilApproved: false,
      tilDeclined: false,
      takeTilID: "",
      itemBankData: {},
      clockData: {},
      clockOnID: "",
      history: [],
      closedDayName: "",
      blockSwaps: false,
      swapOption: false,
      fName: " ",
      lName: " ",
      otherUserID: "",
      profPicUrl: "",
      userID: "",
      iWant: {},
      lateDurMins: 0,
      lateStartDs: "",
      unpaidLate: false,
      createdByClock: false,
      inLieu: false,
      absenceAllowSelfLog: false,
      selfLoggedAbsence: false,
      selfLoggedAbsenceReason: false,
      requireAccept: false,
      accepted: "",
    }
  );

  let [otherUsersArr, setOtherUsersArr] = useState([]);
  let [shiftIsPast, setShiftIsPast] = useState(false);
  const {
    showEditMyShiftModal,
    setShowEditMyShiftModal,
    showTilTrimModal,
    setShowTilTrimModal,
    updateTilData,
    setUpdateTilData,
  } = useContext(CalendarContext);
  const { currencySymbol, checkUserState } = useContext(UserContext);
  const { mobModal } = useContext(StyleContext);
  const {
    updateShifts,
    setUpdateShifts,
    showMyShiftModal,
    setShowMyShiftModal,
    setClockOnID,
    clockOnID,
    showMessages,
    setShowMessages,
    seeUserID,
    setSeeUserID,
    swap,
    setSwap,
    iWant,
    setIWant,
    setIndicate,
    setDynanicSwapOrNote,
    setRemoveMyChangeEditID,
    setShowClockOnModal,
    tilReqMade,
    setAcceptedShiftID,
    setDeclinedShiftID,
    udpateMyRota,
    setUpdateMyRota,
    amendReqSent,
  } = useContext(DataContext);

  const memoVals = useMemo(
    () => ({
      updateShifts,
      setUpdateShifts,
      showMyShiftModal,
      setShowMyShiftModal,
      setClockOnID,
      clockOnID,
      showMessages,
      setShowMessages,
      seeUserID,
      setSeeUserID,
      swap,
      setSwap,
      iWant,
      setIWant,
      setIndicate,
      setDynanicSwapOrNote,
      setRemoveMyChangeEditID,
      setShowClockOnModal,
      tilReqMade,
      setAcceptedShiftID,
      setDeclinedShiftID,
      udpateMyRota,
      setUpdateMyRota,
      amendReqSent,
      mobModal,
      currencySymbol,
      checkUserState,
      showEditMyShiftModal,
      setShowEditMyShiftModal,
      showTilTrimModal,
      setShowTilTrimModal,
      updateTilData,
      setUpdateTilData,
    }),
    [
      updateShifts, //
      setUpdateShifts, //
      showMyShiftModal, //
      setShowMyShiftModal, //
      setClockOnID, //
      clockOnID, //
      showMessages, //
      setShowMessages, //
      seeUserID, //
      setSeeUserID, //
      swap, //
      setSwap, //
      iWant, //
      setIWant, //
      setIndicate, //
      setDynanicSwapOrNote, //
      setRemoveMyChangeEditID, //
      setShowClockOnModal, //
      tilReqMade, //
      setAcceptedShiftID, //
      setDeclinedShiftID, //
      udpateMyRota, //
      setUpdateMyRota, //
      amendReqSent, //
      mobModal, //
      currencySymbol, //
      checkUserState, //
      showEditMyShiftModal, //
      setShowEditMyShiftModal, //
      showTilTrimModal, //
      setShowTilTrimModal, //
      updateTilData, //
      setUpdateTilData, //
    ]
  );

  // const notes = useRef(null);

  let notesBox = useRef();

  useEffect(() => {
    let scrollContainer = notesBox.current;
    if (scrollContainer) {
      const scrollHeight = scrollContainer.scrollHeight;
      const scrollTop = scrollContainer.scrollTop;
      const targetPosition = scrollHeight - scrollContainer.clientHeight;

      const duration = 300; // Adjust this value to set the animation duration in milliseconds
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        scrollContainer.scrollTop =
          scrollTop + progress * (targetPosition - scrollTop);

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };

      requestAnimationFrame(animateScroll);
    }
  }, [memoVals.amendReqSent]);

  // Create a ref to hold the modal element
  const modalRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
  const [modalPosition, setModalPosition] = useState({
    bottom: "0%",
    left: "0%",
  });

  let [dragPosition, setDragPosition] = useState(0);

  const handleDown = (e) => {
    setIsDragging(true);
    setDragStart({
      // x: e.clientX || e.touches[0].clientX,
      y: e.clientY || e.touches[0].clientY,
    });
  };

  const handleMove = (e) => {
    if (isDragging) {
      // const deltaX = (e.clientX || e.touches[0].clientX) - dragStart.x;
      const deltaY = (e.clientY || e.touches[0].clientY) - dragStart.y;

      if (deltaY > 0) {
        setDragPosition(deltaY);
        setModalPosition({
          bottom: `calc(0% - ${deltaY}px)`,
          // left: `calc(0% - ${deltaX}px)`,
        });
      }
    }
  };

  const handleUp = () => {
    setIsDragging(false);

    if (dragPosition > 10) {
      memoVals.setShowMyShiftModal((x) => {
        return {};
      });
    } else {
      setModalPosition({ bottom: "0%", left: "0%" });
    }
  };

  //  - - - - - - -

  // Create a ref to hold the modal element
  const modalRefLogAbs = useRef(null);

  const [isDraggingLogAbs, setIsDraggingLogAbs] = useState(false);
  const [dragStartLogAbs, setDragStartLogAbs] = useState({ x: 0, y: 0 });
  const [modalPositionLogAbs, setModalPositionLogAbs] = useState({
    bottom: "0%",
    left: "0%",
  });

  let [dragPositionLogAbs, setDragPositionLogAbs] = useState(0);

  const handleDownLogAbs = (e) => {
    setIsDraggingLogAbs(true);
    setDragStartLogAbs({
      // x: e.clientX || e.touches[0].clientX,
      y: e.clientY || e.touches[0].clientY,
    });
  };

  const handleMoveLogAbs = (e) => {
    if (isDraggingLogAbs) {
      // const deltaX = (e.clientX || e.touches[0].clientX) - dragStart.x;
      const deltaY = (e.clientY || e.touches[0].clientY) - dragStartLogAbs.y;

      if (deltaY > 0) {
        setDragPositionLogAbs(deltaY);
        setModalPositionLogAbs({
          bottom: `calc(0% - ${deltaY}px)`,
          // left: `calc(0% - ${deltaX}px)`,
        });
      }
    }
  };

  const handleUpLogAbs = () => {
    setIsDraggingLogAbs(false);

    if (dragPositionLogAbs > 10) {
      setShowSelfLogAbsenceModal();
    } else {
      setModalPositionLogAbs({ bottom: "0%", left: "0%" });
    }
  };

  useEffect(() => {
    if (showSelfLogAbsenceModal) {
      setModalPositionLogAbs({ bottom: "0%", left: "0%" });
    }
  }, [showSelfLogAbsenceModal]);
  // --- -- --- -- - --- -

  // Create a ref to hold the modal element
  const modalRefDecline = useRef(null);

  const [isDraggingDecline, setIsDraggingDecline] = useState(false);
  const [dragStartDecline, setDragStartDecline] = useState({ x: 0, y: 0 });
  const [modalPositionDecline, setModalPositionDecline] = useState({
    bottom: "0%",
    left: "0%",
  });

  let [dragPositionDecline, setDragPositionDecline] = useState(0);

  const handleDownDecline = (e) => {
    setIsDraggingDecline(true);
    setDragStartDecline({
      // x: e.clientX || e.touches[0].clientX,
      y: e.clientY || e.touches[0].clientY,
    });
  };

  const handleMoveDecline = (e) => {
    if (isDraggingDecline) {
      // const deltaX = (e.clientX || e.touches[0].clientX) - dragStart.x;
      const deltaY = (e.clientY || e.touches[0].clientY) - dragStartDecline.y;

      if (deltaY > 0) {
        setDragPositionDecline(deltaY);
        setModalPositionDecline({
          bottom: `calc(0% - ${deltaY}px)`,
          // left: `calc(0% - ${deltaX}px)`,
        });
      }
    }
  };

  const handleUpDecline = () => {
    setIsDraggingDecline(false);

    if (dragPositionDecline > 140) {
      setShowDecline(false);
    } else {
      setModalPositionDecline({ bottom: "0%", left: "0%" });
    }
  };

  useEffect(() => {
    if (showDecline) {
      setModalPositionDecline({ bottom: "0%", left: "0%" });
    }
  }, [showDecline]);

  let [sureCancelChange, setSureCancelChange] = useState({
    show: false,
    change: "",
    correspondingEditID: "",
    shiftID: "",
  });

  let [sureCancelTil, setSureCancelTil] = useState(false);
  let [amends, setAmends] = useState([]);
  let [changeRequests, setChangesRequests] = useState([]);

  let clearData = () => {
    setState(null);
  };

  useEffect(() => {
    // cleaned
    const handlePopstate = () => {
      window.history.pushState(null, document.title, window.location.href);
      memoVals.setShowMyShiftModal((x) => false);
    };

    // Add the event listener for "popstate" event
    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener("popstate", handlePopstate);

    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, []);

  let today00 = new Date();
  today00.setHours(0, 0, 0, 0);

  let [shiftDoesNotExist, setShiftDoesNotExist] = useState(false);

  useEffect(() => {
    if (!memoVals.clockOnID) {
      const cancelSource1 = axios.CancelToken.source();
      const cancelSource2 = axios.CancelToken.source();

      axios
        .post(
          `${serverURL}/get-my-single-shift-data`,
          {
            type: unitType,
            typeID: unitID,
            otherUser,
            nowDs: dateStringer.createStringFromTimestamp(new Date().getTime()),
          },

          {
            withCredentials: true,
            credentials: "include",
            cancelToken: cancelSource1.token,
          }
        )
        .then((response) => {
          if (response.data.message === "success") {
            if (shiftDoesNotExist) {
              setShiftDoesNotExist(false);
            }

            setOtherUsersArr(response.data.otherUsers);
            let today = new Date();
            today.setHours(0, 0, 0, 0);
            if (
              dateStringer.createTimestampFromString(response.data.ds) <
              today.getTime()
            ) {
              setShiftIsPast(true);
            }

            response.data.history.sort(
              (a, b) =>
                dateStringer.createTimestampFromString(b.ds) -
                dateStringer.createTimestampFromString(a.ds)
            );

            if (dataLoaded) {
              setDataLoaded(false);
            }
            setDataLoaded(true);
            setState({
              itemType: response.data.type,
              inLieu: response.data.inLieu,
              itemID: unitID,
              itemTeamID: response.data.teamID,
              itemUserID: response.data.userID,
              itemDs: response.data.ds,
              itemStart: response.data.start,
              itemEnd: response.data.end,
              itemBreak: response.data.break,
              itemRate: response.data.rate,
              itemCost: response.data.cost,
              itemDuration: response.data.duration,
              itemNote: response.data.note,
              itemAddedBy: response.data.addedBy,
              itemTeamName: response.data.teamName,
              itemTags: response.data.tags,
              itemAddedByUserID: response.data.addedByUserID,
              itemAbsenceData: response.data.absenceData,
              itemIsAbsent: response.data.absent,
              absenceName: response.data.absenceData
                ? response.data.absenceData.absenceName
                : "",
              ghost: response.data.ghost,
              takeTilRequestMade: response.data.takeTilRequestMade,
              takeTilRequest: response.data.takeTilRequestMade,
              tilStart: response.data.tilStart,
              tilEnd: response.data.tilEnd,
              tilMins: response.data.tilMins,
              tilRequested: response.data.takeTilRequestMade,
              tilApproved: response.data.tilApproved,
              tilDeclined: response.data.tilDeclined,
              takeTilID: response.data.takeTilID,
              itemBankData: response.data.bankData,
              clockData: response.data.clockData,
              clockOnID: response.data.clockOnID,
              salaried: response.data.salaried,
              history: response.data.history,
              closedDayName: response.data.closedDayName,
              swapOption: response.data.swapOption,
              blockSwaps: response.data.blockSwaps,
              fName: response.data.fName,
              lName: response.data.lName,
              otherUserID: response.data.otherUserID,
              profPicUrl: response.data.profPicUrl,
              payClocked: response.data.payClocked,
              lateDurMins: response.data.lateMins,
              lateStartDs: response.data.lateStartDs,
              unpaidLate: response.data.unpaidLate,
              createdByClock: response.data.createdByClock,
              clockable: response.data.clockable,
              clockedOn: response.data.clockedOn,
              absenceAllowSelfLog: response.data.absenceAllowSelfLog,
              selfLoggedAbsence: response.data.selfLoggedAbsence,
              selfLoggedAbsenceReason: response.data.selfLoggedAbsenceReason,
              requireAccept: response.data.requireAccept,
              accepted: response.data.accepted,
            });
            setAmends(response.data.alerts || []);
            // response.data.changesArr.reverse();
            // ((a, b) => {
            //   return (
            //     dateStringer.createTimestampFromString(b.dsMade) -
            //     dateStringer.createStringFromTimestamp(a.dsMade)
            //   );
            // });
            setChangesRequests(response.data.changesArr || []);

            memoVals.setIWant((x) => response.data.iWant);
          }
          if (response.data.message.includes("does not exist")) {
            axios
              .post(
                `${serverURL}/get-my-single-shift-data`,
                {
                  type:
                    unitType === "til" || unitType === "overtime"
                      ? "shift"
                      : "til",
                  typeID: unitID,
                },

                {
                  withCredentials: true,
                  credentials: "include",
                  cancelToken: cancelSource2.token,
                }
              )
              .then((response) => {
                if (response.data.message.includes("not exist")) {
                  setShiftDoesNotExist(true);
                } else {
                }
                if (response.data.message === "success") {
                  setOtherUsersArr(response.data.otherUsers);
                  if (shiftDoesNotExist) {
                    setShiftDoesNotExist(false);
                  }
                  let today = new Date();
                  today.setHours(0, 0, 0, 0);
                  if (
                    dateStringer.createTimestampFromString(response.data.ds) <
                    today.getTime()
                  ) {
                    setShiftIsPast(true);
                  }

                  response.data.history.sort(
                    (a, b) =>
                      dateStringer.createTimestampFromString(b.ds) -
                      dateStringer.createTimestampFromString(a.ds)
                  );
                  if (dataLoaded) {
                    setDataLoaded(false);
                  }
                  setDataLoaded(true);
                  setState({
                    itemType: response.data.type,
                    itemID: unitID,
                    itemTeamID: response.data.teamID,
                    itemUserID: response.data.userID,
                    itemDs: response.data.ds,
                    itemStart: response.data.start,
                    itemEnd: response.data.end,
                    itemBreak: response.data.break,
                    itemRate: response.data.rate,
                    itemCost: response.data.cost,
                    itemDuration: response.data.duration,
                    itemNote: response.data.note,
                    itemAddedBy: response.data.addedBy,
                    itemTeamName: response.data.teamName,
                    itemTags: response.data.tags,
                    itemAddedByUserID: response.data.addedByUserID,
                    itemAbsenceData: response.data.absenceData,
                    itemIsAbsent: response.data.absent,
                    absenceName: response.data.absenceData
                      ? response.data.absenceData.absenceName
                      : "",
                    ghost: response.data.ghost,
                    takeTilRequestMade: response.data.takeTilRequestMade,
                    takeTilRequest: response.data.takeTilRequestMade,
                    tilStart: response.data.tilStart,
                    tilEnd: response.data.tilEnd,
                    tilMins: response.data.tilMins,
                    tilRequested: response.data.takeTilRequestMade,
                    tilApproved: response.data.tilApproved,
                    tilDeclined: response.data.tilDeclined,
                    takeTilID: response.data.takeTilID,
                    itemBankData: response.data.bankData,
                    clockData: response.data.clockData,
                    clockOnID: response.data.clockOnID,
                    salaried: response.data.salaried,
                    history: response.data.history,
                    closedDayName: response.data.closedDayName,
                    swapOption: response.data.swapOption,
                    blockSwaps: response.data.blockSwaps,
                    fName: response.data.fName,
                    lName: response.data.lName,
                    otherUserID: response.data.otherUserID,
                    profPicUrl: response.data.profPicUrl,
                    payClocked: response.data.payClocked,
                    lateDurMins: response.data.lateMins,
                    lateStartDs: response.data.lateStartDs,
                    unpaidLate: response.data.unpaidLate,
                    createdByClock: response.data.createdByClock,
                  });
                  setAmends(response.data.alerts || []);

                  // .sort((a, b) => {
                  //   return (
                  //     dateStringer.createTimestampFromString(b.dsMade) -
                  //     dateStringer.createStringFromTimestamp(a.dsMade)
                  //   );
                  // });
                  setChangesRequests(response.data.changesArr || []);

                  memoVals.setIWant((x) => response.data.iWant);
                }
                if (response.data.message.includes("does not exist")) {
                  clearData();
                }
              })
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          console.error(err);
        });

      return () => {
        cancelSource1.cancel("Component unmounted");
        cancelSource2.cancel("Component unmounted");
      };
    }
  }, [memoVals.updateTilData, memoVals.clockOnID]);

  let calcClockBreak = (cd) => {
    let num = 0;
    if (cd.break1durMins) {
      num += cd.break1durMins;
    }

    if (cd.break2durMins) {
      num += cd.break2durMins;
    }

    if (cd.break3durMins) {
      num += cd.break3durMins;
    }

    return num;
  };

  let enterFct = (e) => {
    if (e.key === "Enter" || e === "add") {
      if (shiftAddNoteValue) {
        setToggleAddNote(false);
        let ds = dateStringer.createStringFromTimestamp(new Date().getTime());
        axios
          .post(
            `${serverURL}/add-note-to-shift`,
            {
              type: state.itemType,
              shiftID: state.itemID,
              ds,
              note: shiftAddNoteValue,
            },

            {
              withCredentials: true,
              credentials: "include",
            }
          )
          .then((response) => {
            if (response.data.message === "success") {
              setShiftAddNoteValue("");

              // response.data.publicNote.sort((a, b) => b.ts - a.ts);

              setState({
                itemNote: [
                  ...state.itemNote,
                  {
                    ds,
                    note: shiftAddNoteValue,
                    fName: response.data.fName,
                    lName: response.data.lName,
                    userID: memoVals.checkUserState.userID,
                    noteID: response.data.noteID,
                    ts: response.data.ts,
                  },
                ],
              });

              memoVals.setDynanicSwapOrNote((x) => {
                return {
                  typeID: state.itemID,
                  swapOrNote: "note",
                  note:
                    response.data.publicNote &&
                    response.data.publicNote.length > 0
                      ? true
                      : false,
                  swap: "",
                };
              });
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    }
  };

  let [showNotes, setShowNotes] = useState(
    memoVals.showMyShiftModal.showNotes || false
  );
  let [toggleAddNote, setToggleAddNote] = useState(false);
  let [shiftAddNoteValue, setShiftAddNoteValue] = useState("");
  // let generateShiftTags = useMemo(() => {
  //   return state.itemTags
  //     ? state.itemTags.map((tag, i) => {
  //         return (
  //           <div
  //             key={`${tag}${tag[i]}`}
  //             className={`tagUnit ${showNotes ? "notesTagUnit" : ""}`}
  //           >
  //             <p className="tagTxt">{tag}</p>
  //             {!showNotes ? (
  //               <img
  //                 className="pullTagImg"
  //                 src={closeGrey}
  //                 alt="Remove tag"
  //                 onClick={() => {
  //                   axios
  //                     .post(
  //                       `${serverURL}/remove-shift-tag`,
  //                       {
  //                         shiftID: state.itemID,
  //                         data: tag,
  //                         type: `${
  //                           state.itemType === "shift" ? "shift" : "til"
  //                         }`,
  //                       },

  //                       {
  //                         withCredentials: true,
  //                         credentials: "include",
  //                       }
  //                     )
  //                     .then((response) => {
  //                       if (response.data.message === "success") {
  //                         setChangesMade(true);

  //                         setState({ tags: response.data.tags });

  //                         // add back to available tags
  //                         // let preAvaTags = availableTags
  //                         if (!availableTags.includes(tag)) {
  //                           setAvailableTags([...availableTags, tag]);
  //                         }
  //                       }
  //                     })
  //                     .catch((err) => {
  //                       console.error(err);
  //                     });
  //                 }}
  //               />
  //             ) : (
  //               ""
  //             )}
  //           </div>
  //         );
  //       })
  //     : "";
  // }, [state.itemTags, showNotes]);

  useEffect(() => {
    // clean not needed
    console.log("SCROLL TO TOP!!");
    if (notesBox.current) {
      notesBox.current.scrollTop = 0;
    }
  }, [showNotes, memoVals.tilReqMade]);

  let addNoteTextArea = useRef();
  useEffect(() => {
    // clean not needed

    if (addNoteTextArea.current) {
      addNoteTextArea.current.focus();
    }
  }, [toggleAddNote]);
  let generateTags = React.useMemo(() => {
    return (
      state.itemTags &&
      state.itemTags.map((tag) => {
        return (
          <p className="itemTag" key={Math.random()}>
            {tag}
          </p>
        );
      })
    );
  }, [state]);

  let calcClockedData = (data) => {
    if (data.startDs) {
      // "startDs": "Y2022M10D11H12M49",
      // "approved": false,
      // "break1durMins": null,
      // "break1endDs": null,
      // "break1startDs": null,
      // "break2durMins": null,
      // "break2endDs": null,
      // "break2startDs": null,
      // "break3durMins": null,
      // "break3endDs": null,
      // "break3startDs": null,

      let endObj = new Date(dateStringer.createTimestampFromString(data.endDs));
      let startObj = new Date(
        dateStringer.createTimestampFromString(data.startDs)
      );
      let durMins = (endObj.getTime() - startObj.getTime()) / 1000 / 60;

      if (data.break1durMins) {
        durMins -= data.break1durMins;
      }

      if (data.break2durMins) {
        durMins -= data.break2durMins;
      }

      if (data.break3durMins) {
        durMins -= data.break3durMins;
      }

      return durMins;
    } else {
      return "";
    }
  };

  let formatName = (name) => {
    if (name) {
      let output = "";
      let stop = false;
      let spaceAt = 0;
      for (var i = 0; i < name.length; i++) {
        if (name.charAt(i) !== " ") {
          if (!stop) {
            output += name.charAt(i);
          }
        } else {
          stop = true;
          spaceAt = i;
        }
      }

      return `${output} ${name.charAt(spaceAt + 1)}`;
    } else {
      return "";
    }
  };

  // state.itemNote.sort((a, b) => b.ts - a.ts);

  let generateNotes =
    state.itemNote && state.itemNote[0]
      ? state.itemNote
          .sort((a, b) => {
            return (
              b.ts - a.ts
              // dateStringer.createTimestampFromString(b.ds) -
              // dateStringer.createTimestampFromString(a.ds)
            );
          })
          .map((note) => {
            let nameVal = `${note.fName} ${note.lName}`;

            let usrLiked = false;
            if (note.likedUserObjects && note.likedUserObjects[0]) {
              note.likedUserObjects.forEach((obj) => {
                if (obj.userID === memoVals.checkUserState.userID) {
                  usrLiked = true;
                }
              });
            }
            return (
              <div className="shiftNotesObj">
                <div className="noteObjNameAndDs">
                  <p
                    className="noteObjName"
                    onClick={() => {
                      console.log(state.itemNote);
                    }}
                  >
                    {nameVal && nameVal.length > 14
                      ? `${note.fName} ${
                          note.lName && note.lName[0] ? note.lName[0] : ""
                        }`
                      : nameVal}
                  </p>
                  <p className="noteObjFsDs">
                    {dateStringer.printedDateWithTimeFromDs(note.ds)}
                  </p>
                </div>
                <p className="noteObjNote">{note.note}</p>
                <div className="deleteNoteRow">
                  {note.likedUserObjects &&
                  note.likedUserObjects[0] &&
                  note.likedUserObjects.length > 0 &&
                  memoVals.checkUserState.userID === state.itemUserID ? (
                    <div className="likedUsersSection">
                      {note.likedUserObjects[0] ? (
                        <p
                          className="ackTitle"
                          onClick={() => {
                            console.log({ usrLiked });
                          }}
                        >
                          Acknowledged:
                        </p>
                      ) : (
                        ""
                      )}
                      {note.likedUserObjects[0] ? (
                        <div
                          className="likedArrMapDiv"
                          onClick={() => {
                            if (showLikedCommentIDs.includes(note.noteID)) {
                              setShowCommentLikedIDs(
                                showLikedCommentIDs.filter((x) => {
                                  return x !== note.noteID;
                                })
                              );
                            } else {
                              setShowCommentLikedIDs([
                                ...showLikedCommentIDs,
                                note.noteID,
                              ]);
                            }
                          }}
                        >
                          {note.likedUserObjects.map((liked, i) => {
                            if (i < 8) {
                              return liked.profPicUrl ? (
                                <img
                                  src={liked.profPicUrl}
                                  alt={liked.fName}
                                  className="ackUsrIcon"
                                />
                              ) : (
                                <p className="ackUsrInitials">
                                  {liked.fName[0]}
                                  {liked.lName[0]}
                                </p>
                              );
                            }
                          })}{" "}
                          {note.likedUserObjects.length > 7 ? (
                            <p className="ackUsrExcess">
                              +{note.likedUserObjects.length - 8}
                            </p>
                          ) : (
                            ""
                          )}
                          {showLikedCommentIDs.includes(note.noteID) ? (
                            ""
                          ) : (
                            <img
                              src={acknowledgeArr}
                              alt="Show acknowledged"
                              className="showAckExpandIcon"
                              onClick={() => {
                                setShowCommentLikedIDs([
                                  ...showLikedCommentIDs,
                                  note.noteID,
                                ]);
                              }}
                            />
                          )}
                        </div>
                      ) : (
                        ""
                      )}
                      {showLikedCommentIDs.includes(note.noteID) ? (
                        <div className="showLikedNamesCom">
                          <img
                            onClick={() => {
                              setShowCommentLikedIDs(
                                showLikedCommentIDs.filter((x) => {
                                  return x !== note.noteID;
                                })
                              );
                            }}
                            src={arrGrey}
                            alt="Acknowledged"
                            className="ackArrClose"
                          />
                          <div className="ackNamesList">
                            {note.likedUserObjects.map((x) => {
                              if (x.userID === memoVals.checkUserState.userID) {
                                return <p className="ackNameItem">Me</p>;
                              } else {
                                return (
                                  <p className="ackNameItem">
                                    {x.fName} {x.lName}
                                  </p>
                                );
                              }
                            })}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  ) : (
                    <p></p>
                  )}
                  {/* <div className="clockNoteAckArr">
            {note.likedUserIDs &&
              note.likedUserIDs[0] &&
              note.likedUserIDs.map((liker) => {
                return liker.substr(0, 3);
              })}
          </div> */}

                  {note.userID === memoVals.checkUserState.userID ? (
                    <img
                      src={bin1}
                      alt="Remove note"
                      className="binNoteImg"
                      onClick={() => {
                        axios
                          .post(
                            `${serverURL}/add-note-to-shift`,
                            {
                              type: state.itemType,
                              shiftID: state.itemID,
                              // ds: dateStringer.createStringFromTimestamp(
                              //   new Date().getTime()
                              // ),
                              // note: shiftAddNoteValue,
                              noteIDifRemoving: note.noteID,
                            },

                            {
                              withCredentials: true,
                              credentials: "include",
                            }
                          )
                          .then((response) => {
                            if (response.data.message === "success") {
                              setToggleAddNote(false);
                              setShiftAddNoteValue("");

                              // response.data.publicNote.sort(
                              //   (a, b) => b.ts - a.ts
                              // );

                              setState({
                                itemNote: state.itemNote.filter((x) => {
                                  return x.noteID !== note.noteID;
                                }),
                              });

                              memoVals.setDynanicSwapOrNote((x) => {
                                return {
                                  typeID: state.itemID,
                                  swapOrNote: "note",
                                  note:
                                    response.data.publicNote &&
                                    response.data.publicNote.length > 0
                                      ? true
                                      : false
                                      ? true
                                      : false,
                                  swap: "",
                                };
                              });
                            }
                          })
                          .catch((err) => {
                            console.error(err);
                          });
                      }}
                    />
                  ) : (
                    <img
                      src={
                        hoveredLikeCommentID === note.noteID && usrLiked
                          ? liked2
                          : usrLiked
                          ? liked
                          : like
                      }
                      alt="Acknowledge note"
                      className={`binNoteImg ${usrLiked ? "x18429814581" : ""}`}
                      onMouseEnter={() => {
                        setHoveredLikeCommentID(note.noteID);
                      }}
                      onMouseLeave={() => {
                        setHoveredLikeCommentID("");
                      }}
                      onClick={() => {
                        setShowCommentLikedIDs(
                          (showLikedCommentIDs || []).filter((x) => {
                            return x !== note.noteID;
                          })
                        );

                        axios
                          .post(
                            `${serverURL}/acknowledge-shift-or-til-comment`,
                            {
                              type: state.itemType,
                              noteID: note.noteID,
                              shiftID: state.itemID,
                              undo: usrLiked ? true : false,
                              nowDs: dateStringer.createStringFromTimestamp(
                                new Date().getTime()
                              ),
                            },

                            {
                              withCredentials: true,
                              credentials: "include",
                            }
                          )
                          .then((response) => {
                            if (response.data.message === "success") {
                              // update here
                              // setUpdate(!update);
                              if (!usrLiked) {
                                memoVals.setIndicate((x) => {
                                  return {
                                    show: true,
                                    message: `Acknowledged ${dateStringer.possession(
                                      note.fName
                                    )} note`,
                                    colour: "green",
                                    duration: 2000,
                                  };
                                });
                              }
                              let newArr = [];
                              state.itemNote.forEach((n) => {
                                if (n.noteID !== note.noteID) {
                                  newArr.push(n);
                                } else {
                                  // amend
                                  if (usrLiked) {
                                    // is undo
                                    // REMOVE IT
                                    let filteredOut = n.likedUserObjects.filter(
                                      (x) => {
                                        return (
                                          x.userID !==
                                          memoVals.checkUserState.userID
                                        );
                                      }
                                    );
                                    newArr.push({
                                      noteID: n.noteID,
                                      note: n.note,
                                      fName: n.fName,
                                      lName: n.lName,
                                      ds: n.ds,
                                      likedUserObjects: filteredOut,
                                      userID: n.noteID,
                                    });
                                  } else {
                                    newArr.push({
                                      noteID: n.noteID,
                                      note: n.note,
                                      fName: n.fName,
                                      lName: n.lName,
                                      ds: n.ds,
                                      likedUserObjects: [
                                        {
                                          fName: response.data.fName,
                                          lName: response.data.lName,
                                          userID:
                                            memoVals.checkUserState.userID,
                                          profPicUrl: response.data.profPicUrl,
                                        },
                                        ...n.likedUserObjects,
                                      ],
                                      userID: n.noteID,
                                    });

                                    // newObj.likedUserObjects.filter((x) => {
                                    //   return x.userID !== memoVals.checkUserState.userID;
                                    // });
                                  }
                                }
                              });

                              console.log({ newArr });
                              setState({ itemNote: newArr });
                            }
                          })
                          .catch((err) => {
                            console.error(err);
                          });
                      }}
                    />
                  )}
                </div>
              </div>
            );
          })
      : "";

  let generateChanges = (
    <div className="changesArrDiv">
      {amends
        .sort((a, b) => {
          return b.ts - a.ts;
        })
        .map((amend) => {
          let change = "";
          if (amend.type === "break") {
            change = (
              <>
                The break was amended from
                <br />
                <span className="amendBoldSpan">
                  {dateStringer.formatMinsDurationToHours(amend.from)}
                </span>{" "}
                to{" "}
                <span className="amendBoldSpan">
                  {dateStringer.formatMinsDurationToHours(amend.to)}
                </span>
              </>
            );
          }
          if (amend.type === "times") {
            change = (
              <>
                The times were amended from
                <br />
                <span className="amendBoldSpan">{amend.from}</span> to{" "}
                <span className="amendBoldSpan">{amend.to}</span>
              </>
            );
          }
          if (amend.type === "date") {
            change = (
              <>
                The date was amended from
                <br />
                <span className="amendBoldSpan">
                  {dateStringer.printedDateFromDs(amend.from)}
                </span>{" "}
                to{" "}
                <span className="amendBoldSpan">
                  {dateStringer.printedDateFromDs(amend.to)}
                </span>
              </>
            );
          }
          if (amend.type === "type") {
            change = (
              <>
                The type was amended from
                <br />
                <span className="amendBoldSpan">{amend.from}</span> to{" "}
                <span className="amendBoldSpan">{amend.to}</span>
              </>
            );
          }
          if (amend.type === "adding") {
            change = (
              <>
                This{" "}
                <span className="amendBoldSpan">
                  {state.itemType === "til" ? "TOIL" : state.itemType}
                </span>{" "}
                was added
              </>
            );
          }
          if (amend.type === "tag") {
            if (amend.to) {
              change = (
                <>
                  The tag <span className="amendBoldSpan">{amend.to}</span> was
                  added
                </>
              );
            }
            if (amend.from) {
              change = (
                <>
                  The tag <span className="amendBoldSpan">{amend.from}</span>{" "}
                  was removed
                </>
              );
            }
          }
          return (
            <div className="shiftAmendUnit">
              <p className="shiftAmendType">{change}</p>
              <p className="shiftAmendBy">by {amend.mgr}</p>
              <p className="shiftAmendWhen">
                on {dateStringer.printedDateFromDs(amend.ds)}
              </p>
              {amend.acknowledged ? (
                <p
                  className={`shiftAmendAck ${
                    memoVals.checkUserState.userID === state.itemUserID
                      ? "none"
                      : ""
                  }`}
                >
                  <img
                    src={greenTick}
                    alt="Acknowledged"
                    className="acknowledgedAmendTickImg"
                  />
                  Acknowledged on{" "}
                  {dateStringer.printedDateFromDs(amend.acknowledged)}
                </p>
              ) : (
                <p
                  className={`shiftAmendAck ${
                    memoVals.checkUserState.userID === state.itemUserID
                      ? "none"
                      : ""
                  }`}
                >
                  Not yet acknowledged by {state.itemFName}
                </p>
              )}
            </div>
          );
        })}
    </div>
  );
  // //  React.useMemo(() => {
  //   return state.history.map((unit, i) => {
  //     if (unit && unit !== "none") {
  //       let final = false;
  //       if (i === state.history.length - 1) {
  //         final = true;
  //       }
  //       return (
  //         <div
  //           className={`shiftHistoryRow ${final ? "shiftHistoryRowFinal" : ""}`}
  //           key={unit.changeID}
  //         >
  //           <p className="shiftHistoryMain myShiftChangesColour">{unit.text}</p>
  //           <div className="shiftHistoryTimeContainer">
  //             <div className="cancelShiftChangeRequestTxtContainer"></div>
  //             <p className="shiftHistoryTime">
  //               {unit.ds.substr(12, 2)}:{unit.ds.substr(15, 2)},{" "}
  //               {dateStringer.printedDateFromDs(unit.ds).substr(4, 6)}
  //             </p>
  //           </div>
  //         </div>
  //       );
  //     }
  //   });
  // }, [state.history]);

  let renderEditMyShiftModal = () => {
    if (memoVals.showEditMyShiftModal) {
      return (
        <EditMyShiftRequestModal
          unitType={state.itemType}
          unitID={state.itemID}
          unitTeamID={state.itemTeamID}
          unitUserID={state.itemUserID}
          unitDs={state.itemDs}
          unitStart={state.itemStart}
          unitEnd={state.itemEnd}
          unitBreak={state.itemBreak}
          setUpdateChangeRequests={setChangesRequests}
        />
      );
    } else {
      return "";
    }
  };

  let renderTilTrimModal = () => {
    if (memoVals.showTilTrimModal) {
      return (
        <TilTrimModal
          unitType={state.itemType}
          unitID={state.itemID}
          unitDate={state.itemDs}
          unitShiftMins={state.itemDuration}
          unitStart={state.itemStart}
          unitEnd={state.itemEnd}
          unitTeamID={state.itemTeamID}
          unitBrkMins={state.itemBreak}
        />
      );
    }
  };

  let shortenTeamName = (name) => {
    if (name.length > 20) {
      return `${name.substr(0, 18)}...`;
    } else {
      return name;
    }
  };

  if (
    !memoVals.clockOnID &&
    !memoVals.seeUserID.userID &&
    !memoVals.showMessages
  ) {
    return (
      <div
        className={`myShiftModalUnderlay ${
          memoVals.swap && memoVals.swap.shiftID ? "invis" : ""
        }`}
        onClick={() => {
          memoVals.setShowMyShiftModal((x) => {
            return {};
          });
          clearData();
        }}
      >
        {loading ? (
          <div
            className={`shiftLoadingBox ${
              memoVals.mobModal
                ? "shiftLoadingBoxMob"
                : "shiftLoadingBoxDesktop"
            }`}
          >
            <img
              src={horizontalBalls}
              alt="Loading"
              className={`shiftLoadingBallsImg ${
                memoVals.mobModal ? "shiftLoadingBallsImgMob" : "zoomIn"
              }`}
            />
          </div>
        ) : (
          <div
            className={`${
              state.itemStart && state.itemEnd && state.itemType
                ? "myShiftModalBox"
                : "none"
            } ${
              memoVals.mobModal
                ? "mobMyShiftModalBox slideUp mobModalShoulder"
                : "zoomIn myShiftModalBoxDesktop"
            }`}
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={modalPosition}
            ref={modalRef}
          >
            {/* <div className="aa22">{parseInt(dragPosition)}</div> */}
            {memoVals.mobModal && <div className="modalSwiper"></div>}
            <div
              className="myShiftHeaderParent"
              onTouchStart={memoVals.mobModal ? handleDown : null}
              onTouchMove={memoVals.mobModal ? handleMove : null}
              onTouchEnd={memoVals.mobModal ? handleUp : null}
              onMouseDown={memoVals.mobModal ? handleDown : null}
              onMouseMove={memoVals.mobModal ? handleMove : null}
              onMouseUp={memoVals.mobModal ? handleUp : null}
            >
              <div className="myShiftHeaderLeft">
                <div
                  className="myShiftModalHeaderContainer"
                  onClick={() => {
                    if (memoVals.mobModal) {
                      memoVals.setShowMyShiftModal((x) => {
                        return {};
                      });
                      clearData();
                    }
                  }}
                >
                  <div
                    className="myShiftCloseHolder"
                    onClick={() => {
                      memoVals.setShowMyShiftModal((x) => {
                        return {};
                      });
                      clearData();
                    }}
                  >
                    <img
                      src={close}
                      alt="Close"
                      className="closeMyShiftModalImg"
                    />
                  </div>
                  <p
                    className="myShiftModalHeaderTitleTxt"
                    onClick={() => {
                      console.log(changeRequests);
                    }}
                  >
                    {state.ghost
                      ? "Paid day off"
                      : state.itemType === "shift"
                      ? `${
                          otherUser
                            ? `${state.fName}${
                                state.fName[state.fName.length - 1] === "s"
                                  ? "'"
                                  : "'s"
                              } shift`
                            : "My Shift"
                        }`
                      : `${
                          state.itemType === "til"
                            ? `${
                                otherUser
                                  ? `${state.fName}${
                                      state.fName[state.fName.length - 1] ===
                                      "s"
                                        ? "'"
                                        : "'s"
                                    } TOIL`
                                  : "My shift in lieu"
                              }`
                            : `${
                                otherUser
                                  ? `${state.fName}${
                                      state.fName[state.fName.length - 1] ===
                                      "s"
                                        ? "'"
                                        : "'s"
                                    } overtime`
                                  : "My overtime"
                              }`
                        }`}{" "}
                  </p>
                  {/* <div className="myShiftModalHeaderRight">&nbsp;</div> */}
                </div>
                <div className="shiftBubblesBar">
                  <div className="shiftTeamSubBubble">
                    {shortenTeamName(state.itemTeamName)}
                  </div>
                  {otherUser ? (
                    <p className="shiftCostBubble salariedCost">
                      {dateStringer.formatMinsDurationToHours(
                        state.itemDuration
                      )}
                    </p>
                  ) : (
                    ""
                  )}
                  {!state.salaried && !otherUser ? (
                    <p
                      className={`${
                        memoVals.checkUserState.showCosts && state.itemCost > 0
                          ? "shiftCostBubble"
                          : "none"
                      }`}
                    >
                      {state.itemCost > 0
                        ? `${memoVals.currencySymbol}${
                            state.itemCost % 1 === 0
                              ? state.itemCost
                              : state.itemCost.toFixed(2)
                          }`
                        : "0"}
                    </p>
                  ) : (
                    ""
                  )}

                  {!state.salaried && !otherUser ? (
                    <p
                      className={`${
                        state.itemBankData.bank &&
                        state.itemBankData.bankCost > 0 &&
                        state.itemType !== "til"
                          ? "shiftCostBubble mgrModalBgShiftCost bankCostBubbleUser"
                          : "none"
                      }`}
                    >
                      +{memoVals.currencySymbol}
                      {Math.round(
                        (state.itemBankData.bankCost + Number.EPSILON) * 100
                      ) / 100}
                    </p>
                  ) : (
                    ""
                  )}
                  {state.salaried && !otherUser ? (
                    <p className="shiftCostBubble salariedCost">Salaried</p>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="myShiftHeaderRight">
                {state.profPicUrl ? (
                  <img
                    src={state.profPicUrl}
                    alt="Shift"
                    className="myShiftProfPicImg"
                    onClick={() => {
                      memoVals.setSeeUserID((x) => {
                        return {
                          userID: state.otherUserID,
                          openedFromUserRota: true,
                        };
                      });
                    }}
                  />
                ) : (
                  <div className="myShiftProfPicBlankDiv">
                    <img
                      src="https://ik.imagekit.io/timelify/propic_CTHtZwj7X.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1662246600966"
                      alt="Shift"
                      className="myShiftBlankProfPicImg"
                      onClick={() => {
                        memoVals.setSeeUserID((x) => {
                          return {
                            userID: state.otherUserID,
                            openedFromUserRota: true,
                          };
                        });
                      }}
                    />
                    <div
                      className="myShiftBlankInitialsHolder"
                      onClick={() => {
                        memoVals.setSeeUserID((x) => {
                          return {
                            userID: state.otherUserID,
                            openedFromUserRota: true,
                          };
                        });
                      }}
                    >
                      {state.fName ? state.fName[0] : ""}
                      {state.lName ? state.lName[0] : ""}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {/* modal body */}
            <div
              className={`myShiftModalBody ${
                memoVals.mobModal
                  ? "mobMyShiftModalBody mobMyShiftModalBody2"
                  : ""
              }`}
              ref={notesBox}
            >
              {showNotes ? (
                <div>
                  <div className="shiftNotesTitleAndAdd myShiftTitleAndAdd">
                    <p className="shiftNotesTitleTxt">Notes</p>
                    <div
                      className={`addClockNoteBtn ${
                        toggleAddNote ? "addClockNoteBtnActive" : ""
                      }`}
                      onClick={() => {
                        setToggleAddNote(!toggleAddNote);
                      }}
                    >
                      Add note{" "}
                      <img
                        src={toggleAddNote ? greyCross : noteImg2}
                        alt="Add note"
                        className={`addNoteInlineImg ${
                          toggleAddNote ? "x19387459" : ""
                        }`}
                      />
                    </div>
                  </div>
                  {toggleAddNote ? (
                    <div className="shiftAddNoteDiv">
                      <textarea
                        ref={addNoteTextArea}
                        className="shiftAddNoteTextArea"
                        value={shiftAddNoteValue}
                        onKeyPress={(e) => {
                          enterFct(e);
                        }}
                        onChange={(e) => {
                          setShiftAddNoteValue(e.target.value);
                        }}
                      ></textarea>
                      <div className="shiftAddNoteRightBtns">
                        <p
                          className={`shiftAddNoteSaveBtn ${
                            !shiftAddNoteValue ? "disableAddNoteBtn" : ""
                          }`}
                          onClick={() => {
                            enterFct("add");
                          }}
                        >
                          Add
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* {memoVals.mobModal && toggleAddNote ? ( */}
                  {/* // "" */}
                  {/* // ) : ( */}
                  <div className="notesHolder">
                    {state.itemNote && state.itemNote[0] ? (
                      generateNotes
                    ) : (
                      <p className="noShiftNotes">No notes yet</p>
                    )}
                  </div>
                  {/* // )}  */}
                </div>
              ) : (
                <div className="">
                  <div className="myShiftRow">
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">When</p>{" "}
                      <p className="myShiftWhenDsStrip">
                        {dateStringer.printedDateFromDs(state.itemDs)}&nbsp;
                        {state.itemDs.substr(1, 4)}
                      </p>
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {state.ghost ? (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft paidTimeOffMyShift">
                        {state.closedDayName || "Paid day off"}
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  ) : (
                    ""
                  )}
                  {!state.ghost ? (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft">
                        <div className="myShiftRowLeftTitle myShiftTimesRowFlex">
                          Times{" "}
                          <p
                            className={`${
                              state.tilApproved ||
                              state.tilDeclined ||
                              state.tilRequested
                                ? `youReqTilSpan ${
                                    state.tilApproved
                                      ? "approved12TilRow"
                                      : `${
                                          state.tilDeclined
                                            ? "declined12TilRow"
                                            : ""
                                        }`
                                  }`
                                : "none"
                            }`}
                          >
                            {`${
                              state.tilDeclined
                                ? `${dateStringer.formatMinsDurationToHours(
                                    state.tilMins
                                  )} TOIL declined`
                                : `${
                                    state.tilApproved ? "" : "Requested"
                                  } ${dateStringer.formatMinsDurationToHours(
                                    state.tilMins
                                  )} TOIL${state.tilApproved ? " approved" : ""}
                          `
                            }`}
                          </p>
                        </div>
                        <div
                          className={`tilSplitShiftContainer ${
                            otherUser ? "maxWidth172" : ""
                          } ${
                            state.tilApproved &&
                            dateStringer.generateTilShiftString(
                              state.tilStart,
                              state.tilEnd,
                              state.itemStart,
                              state.itemEnd,
                              false,
                              "",
                              state.itemType
                            ).length > 14 &&
                            !dateStringer
                              .generateTilShiftString(
                                state.tilStart,
                                state.tilEnd,
                                state.itemStart,
                                state.itemEnd,
                                "",
                                false,
                                state.itemType
                              )
                              .includes("Whole")
                              ? ""
                              : "myShiftTimeStrip"
                          } ${
                            state.itemType !== "shift" &&
                            state.tilApproved &&
                            state.tilStart
                              ? "x139819841"
                              : ""
                          }`}
                        >
                          <div
                            className={`${
                              state.tilApproved &&
                              dateStringer.generateTilShiftString(
                                state.tilStart,
                                state.tilEnd,
                                state.itemStart,
                                state.itemEnd,
                                false,
                                "",
                                state.itemType
                              ).length > 14 &&
                              !dateStringer
                                .generateTilShiftString(
                                  state.tilStart,
                                  state.tilEnd,
                                  state.itemStart,
                                  state.itemEnd,
                                  false,
                                  "",
                                  state.itemType
                                )
                                .includes("Whole")
                                ? "tilABShiftBox"
                                : "none"
                            }`}
                          >
                            <p
                              className={`tilArow ${
                                state.tilApproved
                                  ? "approved12TilRow maxW24"
                                  : ""
                              }`}
                            >
                              1
                            </p>
                            <p
                              className={`tilBrow ${
                                state.tilApproved
                                  ? "approved12TilRow maxW24"
                                  : ""
                              }`}
                            >
                              2
                            </p>
                          </div>

                          <p
                            className={`myShiftTimesRow ${
                              state.tilRequested &&
                              !state.tilApproved &&
                              !state.tilDeclined
                                ? "fadeTilTimes"
                                : ""
                            }`}
                          >
                            <span
                              className={`${
                                state.tilMins === state.itemDuration &&
                                state.takeTilRequestMade &&
                                !state.tilDeclined
                                  ? "allTilOff"
                                  : "none"
                              }`}
                            >
                              Whole {state.itemType} off as TOIL
                            </span>

                            <span
                              className={`${
                                state.tilMins === state.itemDuration &&
                                state.takeTilRequestMade &&
                                !state.tilDeclined
                                  ? "none"
                                  : `shiftTimesStrip ${
                                      dateStringer
                                        .generateTilShiftString(
                                          state.tilStart,
                                          state.tilEnd,
                                          state.itemStart,
                                          state.itemEnd,
                                          false,
                                          "",
                                          state.itemType
                                        )
                                        .includes("Whole")
                                        ? "lineHeight22px"
                                        : ""
                                    }`
                              }`}
                              onClick={() => {
                                console.log({ state });
                              }}
                            >
                              {`${
                                (state.tilRequested || state.tilApproved) &&
                                !state.tilDeclined
                                  ? `${dateStringer.generateTilShiftString(
                                      state.tilStart,
                                      state.tilEnd,
                                      state.itemStart,
                                      state.itemEnd,
                                      false,
                                      "",
                                      state.itemType
                                    )}`
                                  : `${state.itemStart} - ${state.itemEnd}`
                              }`}
                            </span>
                          </p>

                          <p
                            className={`${
                              state.tilRequested &&
                              !state.tilApproved &&
                              !state.tilDeclined
                                ? "tilTimePreviewWhenRequested"
                                : "none"
                            } ${
                              state.tilMins === state.itemDuration &&
                              state.takeTilRequestMade
                                ? "none"
                                : ""
                            }`}
                          >
                            {state.tilStart} - {state.tilEnd}
                          </p>

                          <p
                            className={`${
                              state.takeTilRequestMade &&
                              (state.tilApproved || state.tilDeclined)
                                ? "blankTilSpaceRight"
                                : "none"
                            }`}
                          >
                            &nbsp;{" "}
                          </p>
                        </div>
                        <p
                          className={`${
                            state.tilDeclined ? "tilDeclinedStrip" : "none"
                          }`}
                        >
                          TOIL declined: {state.tilStart} - {state.tilEnd}
                        </p>
                        <div
                          className={`${
                            state.tilApproved || state.tilRequested
                              ? "myShiftTimesRowOriginalRow"
                              : "none"
                          }`}
                        >
                          <p
                            className={`${
                              !state.tilDeclined
                                ? "originalShiftTimeSpan"
                                : "none"
                            }`}
                          >
                            Originally{" "}
                            <span className="originalShiftTimeSpanValue">
                              {"  "}
                              {state.itemStart} - {state.itemEnd}
                            </span>
                          </p>

                          {/* <p
                            className={`${
                              state.tilApproved &&
                              !state.tilRequested &&
                              !state.tilDeclined
                                ? "tilStatusBubble tilApprovedBg"
                                : "none"
                            }`}
                          >
                            TOIL approved
                          </p> */}
                          <p
                            className={`${
                              state.tilDeclined &&
                              !state.tilRequested &&
                              !state.tilApproved
                                ? "tilStatusBubble tilDeclinedBg"
                                : "none"
                            }`}
                          >
                            TOIL declined
                          </p>
                          <p
                            className={`${
                              state.tilRequested &&
                              !state.tilDeclined &&
                              !state.tilApproved
                                ? "tilStatusBubble tilRequestedBg"
                                : "none"
                            }`}
                          >
                            Awaiting approval
                          </p>
                        </div>
                        <div
                          className={`${
                            // buckley

                            state.tilApproved || state.tilRequested
                              ? "cancelTilReqContainer"
                              : "none"
                          } ${
                            dateStringer.createTimestampFromString(
                              state.itemDs
                            ) <= today00.getTime()
                              ? "invis pullCancelTilUpBecauseInPast"
                              : ""
                          }`}
                        >
                          <div
                            className={`${
                              sureCancelTil ? "none" : "removeTil"
                            }`}
                            onClick={() => {
                              if (state.tilDeclined) {
                                axios
                                  .post(
                                    `${serverURL}/remove-til-request`,
                                    {
                                      takeTilID: state.takeTilID,
                                      type: state.itemType,
                                      shiftID: state.itemID,
                                      user: true,
                                      nowDs:
                                        dateStringer.createStringFromTimestamp(
                                          new Date().getTime()
                                        ),
                                    },

                                    {
                                      withCredentials: true,
                                      credentials: "include",
                                    }
                                  )
                                  .then((response) => {
                                    if (response.data.message === "success") {
                                      // TODO
                                      setState({
                                        tilMins: 0,
                                        tilApproved: false,
                                        tilDeclined: false,
                                        tilRequested: false,
                                        takeTilRequest: false,
                                        takeTilRequestMade: false,
                                      });
                                      memoVals.setShowTilTrimModal(
                                        (x) => false
                                      );
                                      memoVals.setUpdateShifts(
                                        (x) => !memoVals.updateShifts
                                      );
                                    } else {
                                    }
                                  })
                                  .catch((err) => {
                                    console.error(err);
                                  });
                              } else {
                                setSureCancelTil(true);
                              }
                            }}
                          >
                            <img
                              src={cancelTil}
                              alt="Cancel TIL"
                              className="cancelTilImg"
                            />
                            {state.tilDeclined
                              ? "Remove TOIL request"
                              : "Cancel TOIL"}
                          </div>

                          <p
                            className={`${
                              sureCancelTil ? "removeTilSure" : "none"
                            }`}
                            onClick={() => {
                              // remove til action here
                              if (
                                state.tilRequested ||
                                state.tilApproved ||
                                state.tilDeclined
                              ) {
                                axios
                                  .post(
                                    `${serverURL}/remove-til-request`,
                                    {
                                      takeTilID: state.takeTilID,
                                      type: state.itemType,
                                      shiftID: state.itemID,
                                      user: true,
                                      nowDs:
                                        dateStringer.createStringFromTimestamp(
                                          new Date().getTime()
                                        ),
                                    },

                                    {
                                      withCredentials: true,
                                      credentials: "include",
                                    }
                                  )
                                  .then((response) => {
                                    if (response.data.message === "success") {
                                      // TODO
                                      setState({
                                        tilMins: 0,
                                        tilApproved: false,
                                        tilDeclined: false,
                                        tilRequested: false,
                                        takeTilRequest: false,
                                        takeTilRequestMade: false,
                                      });
                                      memoVals.setShowTilTrimModal(
                                        (x) => false
                                      );

                                      setSureCancelTil(false);
                                      memoVals.setUpdateShifts(
                                        (x) => !memoVals.updateShifts
                                      );
                                    } else {
                                    }
                                  })
                                  .catch((err) => {
                                    console.error(err);
                                  });
                              }
                            }}
                          >
                            {state.tilDeclined
                              ? "Remove request"
                              : "Cancel TIL"}
                            ?
                          </p>
                          <p className=""></p>
                        </div>
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  {(state.clockable &&
                    !state.clockOnID &&
                    !state.ghost &&
                    !state.itemIsAbsent) ||
                  (state.clockedOn && !state.ghost && !state.itemIsAbsent) ? (
                    <div className="myShiftRow">
                      <p className="offerClockOn">
                        Clock {state.clockedOn ? "off" : "on"} now?
                      </p>
                      <p
                        className="clockOnNowBtn"
                        onClick={() => {
                          memoVals.setShowMyShiftModal((x) => {
                            return {};
                          });
                          clearData();
                          memoVals.setShowClockOnModal((x) => true);
                        }}
                      >
                        Clock {state.clockedOn ? "off" : "on"}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  <div
                    className={`${state.itemIsAbsent ? "myShiftRow" : "none"}`}
                  >
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">Absence</p>
                      <span className="myShiftAbsentTxtRed">
                        {state.itemAbsenceData.partialAbsent
                          ? `${state.itemAbsenceData.partialAbsentStart} - ${state.itemAbsenceData.partialAbsentEnd}`
                          : "Absent all day"}
                        &nbsp;
                        <span
                          className={`${
                            state.itemIsAbsent
                              ? "myShiftAbsentDurationSpan"
                              : "none"
                          }`}
                          onClick={() => {
                            console.log("itemdURATION: ", state.itemDuration);
                          }}
                        >
                          {dateStringer.formatMinsDurationToHours(
                            `${
                              state.itemAbsenceData.partialAbsent
                                ? `${
                                    state.itemAbsenceData
                                      .partialAbsentDuration /
                                    1000 /
                                    60
                                  }`
                                : `${state.itemDuration}`
                            }`
                          ) !== " mins"
                            ? ` ${dateStringer.formatMinsDurationToHours(
                                `${
                                  state.itemAbsenceData.partialAbsent
                                    ? `${
                                        state.itemAbsenceData
                                          .partialAbsentDuration /
                                        1000 /
                                        60
                                      }`
                                    : `${state.itemDuration}`
                                }`
                              )}`
                            : ""}
                        </span>
                        <span
                          className={`${
                            state.itemIsAbsent &&
                            state.itemUserID === memoVals.checkUserState.userID
                              ? "myShiftAbsentDurationSpan"
                              : "none"
                          }`}
                        >
                          &nbsp;-&nbsp;
                          {state.itemAbsenceData.unpaidAbsent
                            ? "Unpaid"
                            : "Paid"}
                        </span>
                      </span>
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}

                  <div
                    className={`${
                      state.lateDurMins > 0 ? "myShiftRow" : "none"
                    }`}
                  >
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">Lateness</p>
                      <span className="shiftTimesStrip colourRed">
                        {dateStringer.formatMinsDurationToHours(
                          state.lateDurMins
                        )}{" "}
                        late &nbsp;
                      </span>
                      <span className="myShiftAbsentDurationSpan">
                        {state.unpaidLate ? "Unpaid" : "Paid"}
                      </span>
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}
                  {state.clockData &&
                  state.clockData.startDs &&
                  state.clockData.endDs ? (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft">
                        {/* <p className="myShiftRowLeftTitle">Clocked times</p> */}

                        <div className="myShiftClockedDiv">
                          <div className="myShiftClockOnOffFlex">
                            <div className="myShiftClockedDivRow">
                              <p className="myShiftClockedDivRowTitle">
                                Clocked on
                              </p>
                              <p className="myShiftClockedDivRowValue">
                                {dateStringer.dsToTimeStrip(
                                  state.clockData.startDs,
                                  true
                                )}
                              </p>
                            </div>
                            <div className="myShiftClockedDivRow">
                              <p className="myShiftClockedDivRowTitle txtAlignRight">
                                Clocked off
                              </p>
                              <p className="myShiftClockedDivRowValue txtAlignRight">
                                {dateStringer.dsToTimeStrip(
                                  state.clockData.endDs,
                                  true
                                )}
                              </p>
                            </div>
                          </div>

                          <div className="myShiftClockOnOffFlex">
                            <div className="myShiftClockedDivRow">
                              <p className="myShiftClockedDivRowTitle">
                                Clocked duration
                              </p>
                              <p className="myShiftClockedDivRowValue">
                                {dateStringer.formatMinsDurationToHours(
                                  calcClockedData(state.clockData)
                                )}{" "}
                              </p>
                            </div>
                            <div className="myShiftClockedDivRow">
                              {otherUser ? (
                                <div className="myShiftClockedDivRow">
                                  <p className="myShiftClockedDivRowTitle txtAlignRight">
                                    Clocked break
                                  </p>
                                  <p className="myShiftClockedDivRowValue txtAlignRight">
                                    {dateStringer.formatMinsDurationToHours(
                                      calcClockBreak(state.clockData)
                                    )}{" "}
                                  </p>
                                </div>
                              ) : (
                                <p
                                  className="viewClockOnMyShiftBtn"
                                  onClick={() => {
                                    memoVals.setClockOnID((x) => {
                                      return {
                                        clockOnID: state.clockOnID,
                                        isMgr: false,
                                        fromShiftManager: false,
                                      };
                                    });
                                  }}
                                >
                                  Clock card{" "}
                                  <img
                                    src={popup}
                                    alt="Clock card"
                                    className="clockCardMyShiftPopUp"
                                  />
                                </p>
                              )}
                              <p
                                className={`myShiftClockStatus ${
                                  state.clockData.approved
                                    ? "ccAPPR"
                                    : state.clockData.declined
                                    ? "ccDECL"
                                    : ""
                                }`}
                              >
                                {state.clockData.approved
                                  ? "Approved"
                                  : state.clockData.declined
                                  ? "Declined"
                                  : "Not yet approved"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  {!otherUser && state.requireAccept ? (
                    <div className="myShiftRow">
                      {/* <div className="myShiftRowLeft"> */}
                      {!state.accepted ? (
                        <p className="offerClockOn">
                          Accept{" "}
                          {state.itemType === "til"
                            ? "shift in lieu"
                            : state.itemType}
                        </p>
                      ) : (
                        <p className="offerClockOn x23894292111">
                          <img
                            src={doubleTick}
                            alt="Accepted"
                            className="myShDoubleTick"
                          />
                          You accepted this{" "}
                          {state.itemType === "til" ? "TOIL" : state.itemType}{" "}
                          on {dateStringer.printedDateFromDs(state.accepted)}
                        </p>
                      )}
                      {!state.accepted ? (
                        <div className="acceptOrDecDiv">
                          {" "}
                          <p
                            className="clockOnNowBtn x991091808312"
                            onClick={() => {
                              let nowDs =
                                dateStringer.createStringFromTimestamp(
                                  new Date().getTime()
                                );
                              axios
                                .post(
                                  `${serverURL}/accept-shift`,
                                  {
                                    shiftID: state.itemID,
                                    type: state.itemType,
                                    nowDs,
                                  },

                                  {
                                    withCredentials: true,
                                    credentials: "include",
                                  }
                                )
                                .then((response) => {
                                  if (response.data.message === "success") {
                                    setState({
                                      accepted: nowDs,
                                    });
                                    memoVals.setAcceptedShiftID(
                                      (x) => state.itemID
                                    );
                                  }
                                });
                            }}
                          >
                            Accept
                            <img
                              src={whiteTick}
                              alt="Absence log"
                              className="absenceLogPopup x13453232d"
                            />
                          </p>
                          <p
                            className="declineShBtn"
                            onClick={() => {
                              setShowDecline(true);
                            }}
                          >
                            Decline
                          </p>
                        </div>
                      ) : (
                        <p></p>
                      )}
                      {/* </div>{" "} */}
                    </div>
                  ) : (
                    ""
                  )}
                  {!otherUser &&
                  state.absenceAllowSelfLog &&
                  !shiftIsPast &&
                  !state.selfLoggedAbsence &&
                  !state.itemIsAbsent ? (
                    <div className="myShiftRow">
                      {/* <div className="myShiftRowLeft"> */}
                      <p className="offerClockOn">Going to be absent?</p>
                      <p
                        className="clockOnNowBtn selfLogAbsColours"
                        onClick={() => {
                          setShowSelfLogAbsenceModal(true);
                          setReason("");
                        }}
                      >
                        Absent
                        <img
                          src={popupX}
                          alt="Absence log"
                          className="absenceLogPopup"
                        />
                      </p>
                      {/* </div>{" "} */}
                    </div>
                  ) : (
                    ""
                  )}
                  {state.selfLoggedAbsence && !otherUser ? (
                    <div className="myShiftRow x48924892875">
                      {/* <div className="myShiftRowLeft"> */}
                      <p className="offerClockOn x1389498523">
                        You have reported yourself as absent
                        <br />
                        <span className="x3928423">
                          {dateStringer.printedDateWithTimeFromDs(
                            state.selfLoggedAbsence
                          )}
                        </span>
                        <br />
                        <span className="x39284232">
                          {state.selfLoggedAbsenceReason}
                        </span>
                        <br />
                        <br />
                        <span className="selfLogApproval">
                          Not yet accepted by your manager
                        </span>
                      </p>
                      <p
                        className="clockOnNowBtn canxSelfAbsenceBtn"
                        onClick={() => {
                          setSureCancelAbsence(true);
                        }}
                      >
                        Cancel
                        {/* <img
                          src={popupX}
                          alt="Absence log"
                          className="absenceLogPopup"
                        /> */}
                      </p>
                      {/* </div>{" "} */}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  {otherUser && state.requireAccept && (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft">
                        {/* <p className="myShiftRowLeftTitle">
                          This{" "}
                          {state.itemType === "til" ? "TOIL" : state.itemType}{" "}
                          requires accepting
                        </p> */}

                        {state.accepted ? (
                          <span className="myShiftBreakSpan x189398311">
                            {state.fName} accepted this{" "}
                            {state.itemType === "til" ? "TOIL" : state.itemType}{" "}
                            on {dateStringer.printedDateFromDs(state.accepted)}
                          </span>
                        ) : (
                          <span className="myShiftBreakSpan">
                            {state.fName} has yet to accept this{" "}
                            {state.itemType === "til" ? "TOIL" : state.itemType}{" "}
                          </span>
                        )}
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  )}
                  {/* end of row */}
                  {/* new row */}
                  <div
                    className={`${
                      state.itemIsAbsent && !state.itemAbsenceData.partialAbsent
                        ? "none"
                        : "myShiftRow"
                    }`}
                  >
                    <div className="myShiftRowLeft">
                      <p
                        className="myShiftRowLeftTitle"
                        onClick={() => {
                          console.log(
                            "ddd: ",
                            `${
                              state.tilApproved
                                ? state.itemDuration - state.tilMins
                                : state.itemDuration
                            }`,
                            `${dateStringer.formatMinsDurationToHours(
                              parseInt(
                                `${
                                  state.tilApproved
                                    ? state.itemDuration - state.tilMins
                                    : state.itemDuration
                                }`
                              )
                            )}`
                          );
                        }}
                      >
                        {state.itemType === "til"
                          ? "Duration earned"
                          : state.inLieu
                          ? "Duation (payable & added to TOIL)"
                          : "Payable duration"}
                      </p>
                      <p
                        className={`${
                          state.tilMins === state.itemDuration &&
                          state.takeTilRequestMade &&
                          !state.tilDeclined
                            ? "wholeTilTxt"
                            : "none"
                        }`}
                      >
                        All{" "}
                        {dateStringer.formatMinsDurationToHours(
                          state.itemDuration
                        )}{" "}
                        are {state.tilApproved ? "taken" : "requested"} off as
                        TOIL
                      </p>
                      <span
                        className={`${
                          state.tilMins !== state.itemDuration ||
                          !state.takeTilRequestMade ||
                          state.tilDeclined
                            ? ""
                            : "none"
                        }`}
                      >
                        {" "}
                        {`${
                          state.itemDuration === 0
                            ? "0 mins"
                            : `${dateStringer.formatMinsDurationToHours(
                                state.itemDuration < 0
                                  ? 0
                                  : state.itemDuration || 0
                              )}`
                        }`}{" "}
                      </span>
                      &nbsp;
                      {state.tilMins === state.itemDuration &&
                      state.takeTilRequestMade &&
                      !state.tilDeclined ? (
                        <span className="myShiftBreakSpan x389427232212">
                          {dateStringer.formatMinsDurationToHours(
                            state.itemDuration
                          )}{" "}
                          payable
                        </span>
                      ) : !state.ghost && !state.payClocked ? (
                        <span className="myShiftBreakSpan">
                          /{" "}
                          {dateStringer.formatMinsDurationToHours(
                            state.itemBreak || 0
                          )}{" "}
                          {state.itemType === "til" || state.inLieu
                            ? "excluded break"
                            : "unpaid break"}
                        </span>
                      ) : (
                        ""
                      )}
                      <p
                        className={`${
                          state.tilApproved ? "tilAccountTxt" : "none"
                        } ${
                          state.tilMins === state.itemDuration &&
                          state.takeTilRequestMade
                            ? "none"
                            : ""
                        }`}
                      >
                        {" "}
                        Takes into account{" "}
                        {dateStringer.formatMinsDurationToHours(
                          state.tilMins
                        )}{" "}
                        of TOIL
                      </p>
                      {state.inLieu ? (
                        <div className="inLieuMyShiftTxt">
                          <p className="shiftInlieuSpan">Shift in lieu</p>You
                          will be paid for this shift, and the payable duration
                          will be added to your TOIL balance for you to claim
                          time off from other scheduled shifts
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {memoVals.iWant.dsMade && otherUser ? (
                    <div className="myShiftSwappedRow ">
                      <div className="swappedTitleItem">
                        <img
                          src={navySwap}
                          alt="Swap"
                          className="navySwapImg"
                        />
                        Swap requested
                      </div>
                      <p className="awaitingSwapTxt">
                        {state.fName} has yet to accept
                      </p>
                      <p className="swappedWith">
                        <p className="swappedWithString">
                          You requested{" "}
                          {memoVals.iWant.offerNothing
                            ? `to take this ${
                                state.itemType === "til"
                                  ? "TOIL"
                                  : state.itemType
                              } from ${state.fName}`
                            : `this ${
                                state.itemType === "til"
                                  ? "TOIL"
                                  : state.itemType
                              } from ${state.fName} in return for your ${
                                memoVals.iWant.offeredType === "til"
                                  ? "TOIL:"
                                  : `${memoVals.iWant.offeredType}:`
                              }`}
                        </p>
                        {memoVals.iWant.offerNothing ||
                        memoVals.iWant.noLongerExists ? (
                          <div className="myShiftSwappedItem">
                            <div className="myShiftSwappedItemLeft">
                              <div className="myShiftSwappedItemHalf">
                                <p className="noShiftOfferedTxt">
                                  {memoVals.iWant.noLongerExists
                                    ? "Nothing"
                                    : "No shift offered"}
                                </p>
                                {memoVals.iWant.noLongerExists ? (
                                  <p className="noLongerExistsTxt">
                                    Shift no longer exists
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="myShiftSwappedItemRight">
                              <img
                                src={editGrey}
                                alt="Edit"
                                className="myShiftSwapEditBtnImg"
                                onClick={() => {
                                  memoVals.setSwap((x) => {
                                    return {
                                      shiftID: state.itemID,
                                      type: state.itemType,
                                    };
                                  });
                                }}
                              />
                              <img
                                src={greyCross}
                                alt="Edit"
                                className="myShiftSwapEditBtnImg"
                                onClick={() => {
                                  axios
                                    .post(
                                      `${serverURL}/remove-swap-request`,
                                      {
                                        wanterUserID:
                                          memoVals.checkUserState.userID,
                                        shiftID: state.itemID,
                                        type: state.itemType,
                                        cancellingOwnSwap: true,
                                      },

                                      {
                                        withCredentials: true,
                                        credentials: "include",
                                      }
                                    )
                                    .then((response) => {
                                      if (response.data.message === "success") {
                                        memoVals.setIndicate((x) => {
                                          return {
                                            show: true,
                                            message: "Removed swap request",
                                            colour: "blue",
                                            duration: 4000,
                                          };
                                        });
                                        setIWant((x) => {
                                          return {};
                                        });
                                        memoVals.setDynanicSwapOrNote((x) => {
                                          return {
                                            typeID: state.itemID,
                                            swapOrNote: "swap",
                                            note: "",
                                            swap: false,
                                          };
                                        });
                                      }
                                    })
                                    .catch((err) => {
                                      console.error(err);
                                    });
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="myShiftSwappedItem">
                            <div className="myShiftSwappedItemLeft">
                              <div className="myShiftSwappedItemHalf">
                                <p className="myShiftSwappedItemLeftDs">
                                  {dateStringer.printedDateFromDs(
                                    memoVals.iWant.offeredStartDs
                                  )}
                                </p>

                                <div className="myShiftSwappedItemLeftBrk">
                                  <p>
                                    {dateStringer.dsToTimeStrip(
                                      memoVals.iWant.offeredStartDs
                                    )}{" "}
                                    -{" "}
                                    {dateStringer.dsToTimeStrip(
                                      memoVals.iWant.offeredEndDs
                                    )}
                                  </p>

                                  <p>
                                    {dateStringer.formatMinsDurationToHours(
                                      memoVals.iWant.offeredDurMins
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="myShiftSwappedItemRight">
                              <img
                                src={editGrey}
                                alt="Edit"
                                className="myShiftSwapEditBtnImg"
                                onClick={() => {
                                  memoVals.setSwap((x) => {
                                    return {
                                      shiftID: state.itemID,
                                      type: state.itemType,
                                    };
                                  });
                                }}
                              />
                              <img
                                src={greyCross}
                                alt="Edit"
                                className="myShiftSwapEditBtnImg"
                                onClick={() => {
                                  axios
                                    .post(
                                      `${serverURL}/remove-swap-request`,
                                      {
                                        wanterUserID:
                                          memoVals.checkUserState.userID,
                                        shiftID: state.itemID,
                                        type: state.itemType,
                                        cancellingOwnSwap: true,
                                      },

                                      {
                                        withCredentials: true,
                                        credentials: "include",
                                      }
                                    )
                                    .then((response) => {
                                      if (response.data.message === "success") {
                                        memoVals.setIndicate((x) => {
                                          return {
                                            show: true,
                                            message: "Removed swap request",
                                            colour: "blue",
                                            duration: 4000,
                                          };
                                        });
                                        memoVals.setIWant((x) => {
                                          return {};
                                        });
                                        memoVals.setDynanicSwapOrNote((x) => {
                                          return {
                                            typeID: state.itemID,
                                            swapOrNote: "swap",
                                            note: "",
                                            swap: false,
                                          };
                                        });
                                      }
                                    })
                                    .catch((err) => {
                                      console.error(err);
                                    });
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* new row */}
                  <div
                    className={`${state.absenceName ? "myShiftRow" : "none"}`}
                  >
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">Absence</p>
                      {state.absenceName}
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}
                  {state.itemAbsenceData.unpaidAbsent &&
                  !state.itemAbsenceData.partialAbsent ? (
                    ""
                  ) : memoVals.checkUserState.userID === state.itemUserID &&
                    state.itemType !== "til" ? (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft">
                        <p className="myShiftRowLeftTitle">Rate of pay</p>
                        {state.itemRate}x{" "}
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  <div
                    className={`${
                      state.itemTags && state.itemTags.length > 0
                        ? "myShiftRow"
                        : "none"
                    }`}
                  >
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">Tags & duties</p>
                      <div className="myShiftTagsContainer">{generateTags}</div>
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}
                  {!otherUser ? (
                    <div
                      className={`${
                        state.swapOption &&
                        dateStringer.createTimestampFromString(state.itemDs) >=
                          today00.getTime() &&
                        !state.ghost &&
                        !state.itemIsAbsent &&
                        (!state.clockData ||
                          (state.clockData && !state.clockData.startDs))
                          ? `myShiftRow ${
                              !memoVals.mobModal
                                ? "myShiftAllowSwapsRowHover"
                                : ""
                            }`
                          : "none"
                      }`}
                      onClick={() => {
                        axios
                          .post(
                            `${serverURL}/block-shift-swaps`,
                            {
                              type:
                                state.itemType === "overtime"
                                  ? "til"
                                  : state.itemType,
                              shiftID: state.itemID,
                              data: !state.blockSwaps,
                            },

                            {
                              withCredentials: true,
                              credentials: "include",
                            }
                          )
                          .then((response) => {
                            if (response.data.message === "success") {
                              setState({ blockSwaps: response.data.data });
                            }
                          })
                          .catch((err) => {
                            console.error(err);
                          });
                      }}
                    >
                      {state.ghost || state.itemIsAbsent ? (
                        ""
                      ) : (
                        <div className="myShiftAllowSwapsRow">
                          <p className="myShiftAllowSwapsTitle">Allow swaps</p>
                          {/*  KNOB BEGIN */}
                          <div className="knobContainer myShiftAllowSwapsKnob">
                            <div
                              className={`switchKnob ${
                                !state.blockSwaps
                                  ? "knobOn knobOnMgrColour"
                                  : "knobOff"
                              }`}
                            ></div>
                            <div className="knobBg"></div>
                          </div>
                          {/*  KNOB END */}{" "}
                        </div>
                      )}
                    </div>
                  ) : state.itemNote && state.itemNote[0] ? (
                    <div className="myShiftNotesContainerOtherUser">
                      <p className="myShiftRowLeftTitle myShiftOtherUserNotesTitle">
                        Notes
                      </p>
                      {generateNotes}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  <div className="myShiftRow">
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">
                        Colleagues working the same day
                      </p>

                      {!otherUsersArr[0] ? (
                        <p className="x991ddz">
                          Nobody else is scheduled to work this day in{" "}
                          {state.itemTeamName}
                        </p>
                      ) : (
                        <div className="myShiftOtherUsersBlock">
                          {otherUsersArr.map((user) => {
                            return (
                              <div className="myShOtherUserRow">
                                <img
                                  onClick={() => {
                                    memoVals.setSeeUserID((x) => {
                                      return {
                                        userID: user.userID,
                                        openedFromUserRota: false,
                                      };
                                    });
                                  }}
                                  src={user.pic || profilePicturePlaceholder}
                                  className="otherUsrShImg"
                                  alt={user.fName}
                                />
                                <div className="otherUsrShName">
                                  <p
                                    className="otherUsrShNameTop"
                                    onClick={() => {
                                      memoVals.setSeeUserID((x) => {
                                        return {
                                          userID: user.userID,
                                          openedFromUserRota: false,
                                        };
                                      });
                                    }}
                                  >
                                    {user.userID ===
                                    memoVals.checkUserState.userID
                                      ? "You"
                                      : user.fName}{" "}
                                    {user.userID ===
                                    memoVals.checkUserState.userID
                                      ? ""
                                      : user.lName}
                                  </p>
                                  <div className="otherUsrShNameLow">
                                    {user.items.map((x) => {
                                      return (
                                        <p className="otherUserShItem">
                                          <img
                                            src={rotaClock2}
                                            alt="times"
                                            className="otherUsrClock"
                                          />
                                          {dateStringer.dsToTimeStrip(
                                            x.startDs
                                          )}{" "}
                                          -{" "}
                                          {dateStringer.dsToTimeStrip(x.endDs)}
                                        </p>
                                      );
                                    })}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}

                  {changeRequests[0] ? (
                    <div className="myShiftRow changesArrRow">
                      <p className="shiftHistoryTitle reqsToChangeTitle">
                        Requests to change this{" "}
                        {state.itemType === "til" ? "TOIL" : state.itemType}
                      </p>
                      <div className="changesArrDiv">
                        {changeRequests
                          .sort((a, b) => {
                            return b.tsMade - a.tsMade;
                          })
                          .map((change, i) => {
                            let oldStartCorrect = change.oldStart;
                            let oldEndCorrect = change.oldEnd;

                            if (change.oldStart.includes(":")) {
                              oldStartCorrect = `${change.newDs.substr(
                                0,
                                11
                              )}H${change.oldStart.substr(
                                0,
                                2
                              )}M${change.oldStart.substr(3, 2)}`;
                            }

                            if (change.oldEnd.includes(":")) {
                              oldEndCorrect = `${change.newDs.substr(
                                0,
                                11
                              )}H${change.oldEnd.substr(
                                0,
                                2
                              )}M${change.oldEnd.substr(3, 2)}`;
                            }

                            let oldStartObj = new Date(
                              dateStringer.createTimestampFromString(
                                oldStartCorrect
                              )
                            );
                            let oldEndObj = new Date(
                              dateStringer.createTimestampFromString(
                                oldEndCorrect
                              )
                            );

                            if (oldEndObj.getTime() <= oldStartObj.getTime()) {
                              oldEndObj.setDate(oldEndObj.getDate() + 1);
                              oldEndCorrect =
                                dateStringer.createStringFromTimestamp(
                                  oldEndObj.getTime()
                                );
                            }

                            let dateChanged =
                              change.oldDs.substr(0, 11) !==
                              change.newDs.substr(0, 11);
                            let startChanged =
                              oldStartCorrect !== change.newStart;
                            let endChanged = oldEndCorrect !== change.newEnd;
                            let breakChanged = change.oldBrk !== change.newBrk;

                            let oldStartObj2 = new Date(
                              dateStringer.createTimestampFromString(
                                oldStartCorrect
                              )
                            );
                            let oldEndObj2 = new Date(
                              dateStringer.createTimestampFromString(
                                oldEndCorrect
                              )
                            );
                            let oldDurMins =
                              (oldEndObj2.getTime() - oldStartObj2.getTime()) /
                                1000 /
                                60 -
                              (change.oldBrk || 0);

                            let newStartObj = new Date(
                              dateStringer.createTimestampFromString(
                                change.newStart
                              )
                            );
                            let newEndObj = new Date(
                              dateStringer.createTimestampFromString(
                                change.newEnd
                              )
                            );
                            let newDurMins =
                              (newEndObj.getTime() - newStartObj.getTime()) /
                                1000 /
                                60 -
                              (change.newBrk || 0);
                            return (
                              <div
                                className={`myShiftChangeArrUnit ${
                                  !change.approved && !change.declined
                                    ? "myShPendingChLeftBorder"
                                    : ""
                                }`}
                                onClick={() => {
                                  console.log(
                                    dateChanged,
                                    change.oldDs,
                                    change.newDs
                                  );
                                }}
                              >
                                <div className="changeUnitTop">
                                  <p className="changeUnitTitle">
                                    Change request
                                  </p>
                                  <p
                                    className={
                                      change.approved
                                        ? "changeApprovedStat"
                                        : change.declined
                                        ? "changeDeclinedStat"
                                        : "changePendingStat"
                                    }
                                  >
                                    {change.approved
                                      ? "Approved"
                                      : change.declined
                                      ? "Declined"
                                      : "Pending"}{" "}
                                    {!change.approved && !change.declined ? (
                                      <img
                                        onClick={() => {
                                          console.log(
                                            "corres",
                                            change.correspondingEditID,
                                            "editid",
                                            change.editID
                                          );
                                          setSureCancelChange({
                                            show: true,
                                            change: state.itemType,
                                            correspondingEditID:
                                              change.correspondingEditID ||
                                              change.editID,
                                            shiftID: state.itemID,
                                            editID:
                                              change.correspondingEditID ||
                                              change.editID,
                                          });
                                        }}
                                        src={cancelTil}
                                        alt="Cancel request"
                                        className="cancelReqInMyShiftImg"
                                      />
                                    ) : (
                                      ""
                                    )}
                                  </p>
                                </div>
                                <div className="changeReqDs">
                                  Requested{" "}
                                  {dateStringer.printedDateWithTimeFromDs(
                                    change.dsMade
                                  )}
                                </div>
                                <div className="changeItemsDiv">
                                  {dateChanged ? (
                                    <p
                                      className={`changeItemRow ${
                                        change.approved ? "chAppBorder" : ""
                                      } ${
                                        change.declined ? "chDecBorder" : ""
                                      }`}
                                    >
                                      Date change from
                                      <br />
                                      {dateStringer.printedDateFromDs(
                                        change.oldDs
                                      )}{" "}
                                      to{" "}
                                      {dateStringer.printedDateFromDs(
                                        change.newDs
                                      )}
                                    </p>
                                  ) : (
                                    ""
                                  )}

                                  {startChanged ? (
                                    <p
                                      className={`changeItemRow ${
                                        change.approved ? "chAppBorder" : ""
                                      } ${
                                        change.declined ? "chDecBorder" : ""
                                      }`}
                                    >
                                      Start time change from{" "}
                                      {dateStringer.dsToTimeStrip(
                                        oldStartCorrect
                                      )}{" "}
                                      to{" "}
                                      {dateStringer.dsToTimeStrip(
                                        change.newStart
                                      )}
                                    </p>
                                  ) : (
                                    ""
                                  )}

                                  {endChanged ? (
                                    <p
                                      className={`changeItemRow ${
                                        change.approved ? "chAppBorder" : ""
                                      } ${
                                        change.declined ? "chDecBorder" : ""
                                      }`}
                                    >
                                      End time change from{" "}
                                      {dateStringer.dsToTimeStrip(
                                        oldEndCorrect
                                      )}{" "}
                                      to{" "}
                                      {dateStringer.dsToTimeStrip(
                                        change.newEnd
                                      )}
                                    </p>
                                  ) : (
                                    ""
                                  )}

                                  {breakChanged ? (
                                    <p
                                      className={`changeItemRow ${
                                        change.approved ? "chAppBorder" : ""
                                      } ${
                                        change.declined ? "chDecBorder" : ""
                                      }`}
                                    >
                                      Break duration change from{" "}
                                      {dateStringer.formatMinsDurationToHours(
                                        change.oldBrk
                                      )}{" "}
                                      to{" "}
                                      {dateStringer.formatMinsDurationToHours(
                                        change.newBrk
                                      )}
                                    </p>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                {oldDurMins !== newDurMins ? (
                                  <p className="changeShiftDurMinsDiff">
                                    Old duration:{" "}
                                    <span className="changeDurSpanMins">
                                      {dateStringer.formatMinsDurationToHours(
                                        oldDurMins
                                      )}
                                    </span>
                                    <br /> New duration:{" "}
                                    <span className="changeDurSpanMins">
                                      {dateStringer.formatMinsDurationToHours(
                                        newDurMins
                                      )}
                                    </span>
                                  </p>
                                ) : (
                                  <p className="changeShiftDurMinsDiff">
                                    No change to duration
                                  </p>
                                )}

                                {change.note ? (
                                  <p className="chNote">
                                    <span className="chNoteSpanTitle">
                                      Note:
                                    </span>{" "}
                                    {change.note}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  <div
                    className={`${
                      state.itemBankData.bank ? "myShiftRow" : "none"
                    }`}
                  >
                    <div className="myShiftRowLeft">
                      <p className="myShiftRowLeftTitle">
                        Accrued leave to be paid
                      </p>
                      {dateStringer.formatMinsDurationToHours(
                        state.itemBankData.bankDurMins
                      )}{" "}
                      <span
                        className={`${
                          state.itemBankData.bankCost
                            ? "bankToBePaidSpan"
                            : "none"
                        }`}
                      >
                        / {memoVals.currencySymbol}
                        {Math.round(
                          state.itemBankData.bankCost * 100 + Number.EPSILON
                        ) / 100}
                      </span>
                    </div>
                    <div className="myShiftRowRight"></div>
                  </div>
                  {/* end of row */}
                  {/* new row */}
                  {state.history[0] ? (
                    <div className="myShiftRow">
                      <div className="myShiftRowLeft">
                        <p className="shiftHistoryTitle">History</p>
                        {state.history[0] !== "none" ? generateChanges : ""}
                        <div className="noChangesContainer">
                          <p
                            className={`${
                              state.history[0] === "none"
                                ? "noChangesTxt"
                                : "none"
                            }`}
                          >
                            {state.history[0] === "none"
                              ? `No changes have been made to this ${
                                  state.itemType === "shift"
                                    ? "shift"
                                    : `${
                                        state.itemType === "overtime"
                                          ? "overtime"
                                          : "TOIL"
                                      }`
                                }`
                              : ""}
                          </p>
                        </div>
                        {/* <p className="myShiftRowLeftTitle">Note</p>
                  <p className="itemNote">{state.itemNote[0] ? "notes" : ""}</p> */}
                      </div>
                      <div className="myShiftRowRight"></div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/* end of row */}
                  {/* new row */}
                  {/* <div className={`${state.itemAddedBy ? "myShiftRow" : "none"}`}>
                  <div className="myShiftRowLeft">
                    <p className="myShiftRowLeftTitle">Added by</p>{" "}
                    {`${
                      state.itemAddedByUserID === memoVals.checkUserState.userID
                        ? "You"
                        : `${formatName(state.itemAddedBy)}`
                    }`}
                  </div>

                  <div className="myShiftRowRight"></div>
                </div> */}
                  {/* end of row */}
                  {/* </div> */}
                  {/* -------------------------- */}
                  {/* body history */}
                  {/* <div
              className={`${showNotes ? "shiftHistoryContainer" : "none"}`}
            >
              <p className="shiftHistoryTitle">History &amp; changes</p>
              {history[0] !== "none" ? generateChanges : ""}
              <div className="noChangesContainer">
                <p
                  className={`${
                    history[0] === "none" ? "noChangesTxt" : "none"
                  }`}
                >
                  {history[0] === "none"
                    ? `No changes have been made to this ${
                        state.itemType === "shift"
                          ? "shift"
                          : `${
                              state.itemType === "overtime"
                                ? "overtime"
                                : "time in lieu"
                            }`
                      }`
                    : ""}
                </p>
              </div>
            </div> */}
                </div>
              )}

              {/* end of body history */}
            </div>
            {/* end of modal body middle bit */}
            {/* modal footer */}
            <div
              className={`myShiftModalFooter ${
                memoVals.mobModal ? "mobMyShiftModalFooter" : ""
              }`}
            >
              {otherUser ? (
                <div
                  className={`myShiftModalFooterLeftMyShiftOtheruser ${
                    !dataLoaded ? "invis" : ""
                  }`}
                >
                  {otherUser &&
                  new Date().setHours(0, 0, 0, 0) <=
                    dateStringer.createTimestampFromString(state.itemDs) &&
                  state.swapOption &&
                  !state.blockSwaps &&
                  !state.ghost ? (
                    <p
                      className={`shiftSwapButton ${
                        showNotes ? "showNotesOpenShiftSwap" : ""
                      }`}
                      onClick={() => {
                        // console.log(
                        //   new Date().setHours(0, 0, 0, 0) <=
                        //     dateStringer.createTimestampFromString(state.itemDs)
                        // );

                        memoVals.setSwap((x) => {
                          return {
                            shiftID: state.itemID,
                            type: state.itemType,
                          };
                        });
                      }}
                    >
                      <img src={swap2} alt="Swap" className="swapBtnImg" />
                      Swap
                    </p>
                  ) : (
                    ""
                  )}
                  {otherUser ? (
                    <p
                      className={`myShiftMessageBtn`}
                      onClick={() => {
                        memoVals.setShowMessages((x) => state.otherUserID);
                      }}
                    >
                      <img src={chat} alt="Swap" className="myShiftMsgImg" />
                      Message
                    </p>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                <div className="myShiftModalFooterLeftMyShift">
                  <div
                    className={`${
                      showNotes
                        ? `requestShiftHistoryBtnContainerActive`
                        : `requestShiftHistoryBtnContainer`
                    } `}
                    onClick={() => {
                      setShowNotes(!showNotes);
                    }}
                  >
                    <img
                      src={whitecross}
                      className={`${
                        showNotes ? "closeHistoryShiftImgCross" : "none"
                      }`}
                      alt="Close"
                    />
                    <div
                      className={`${
                        showNotes
                          ? "requestShiftHistoryBtnTxtActive"
                          : `requestShiftHistoryBtnTxtInactive ${
                              state.itemNote && state.itemNote.length > 0
                                ? `activeNoteBtnColours ${
                                    !memoVals.mobModal ? "x1313322" : ""
                                  }`
                                : ""
                            }`
                      }`}
                      onClick={() => {}}
                    >
                      {" "}
                      {showNotes ? (
                        ""
                      ) : (
                        <img
                          src={state.itemNote[0] ? noteImg2 : noteImg}
                          alt="Notes"
                          className="myShiftNoteCommentIcon"
                        />
                      )}
                      Notes{" "}
                      <span
                        className={`${
                          state.itemNote && state.itemNote.length > 9
                            ? "x98472515"
                            : "x5362"
                        } ${showNotes ? "none" : ""} ${
                          state.itemNote && state.itemNote.length === 0
                            ? "none"
                            : ""
                        }`}
                      >
                        (
                        {state.itemNote && state.itemNote[0]
                          ? state.itemNote.length < 10
                            ? state.itemNote.length
                            : `9+`
                          : 0}
                        )
                      </span>
                    </div>
                  </div>
                  {!otherUser && !state.clockOnID && !state.ghost ? (
                    <div
                      className={`requestShiftEditBtnContainer ${
                        showNotes ||
                        state.itemAbsenceData.absent ||
                        shiftIsPast ||
                        state.createdByClock
                          ? "none"
                          : ""
                      }`}
                    >
                      <p
                        className="requestShiftEditBtnTxt x139714"
                        onClick={() => {
                          memoVals.setShowEditMyShiftModal((x) => true);
                          setShowNotes(false);
                        }}
                      >
                        Edit
                        <img
                          src={edit}
                          alt="Take TOIL"
                          className="myShiftEditBtnImg"
                        />
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                  {!otherUser &&
                  !state.clockOnID &&
                  !state.ghost &&
                  state.itemType === "shift" ? (
                    <div
                      className={`${
                        state.itemType === "til" ||
                        !memoVals.checkUserState.tilEnabled
                          ? "takeTilBtnContainer overtimeHTiLDisable"
                          : `takeTilBtnContainer`
                      } ${
                        showNotes ||
                        state.itemAbsenceData.absent ||
                        shiftIsPast ||
                        state.createdByClock
                          ? "none"
                          : ""
                      } 
       
              `}
                    >
                      <p
                        className="takeTilBtn"
                        onClick={() => {
                          if (state.itemType !== "til") {
                            if (
                              memoVals.checkUserState.tilEnabled &&
                              !state.itemAbsenceData.absent
                            ) {
                              memoVals.setShowTilTrimModal((x) => true);
                            }
                          }
                        }}
                      >
                        TOIL{" "}
                        <img
                          src={scissors}
                          alt="Take TOIL"
                          className="myShiftEditBtnImg"
                        />
                      </p>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              <div
                className="myShiftModalFooterRight"
                onClick={() => {
                  clearData();
                  memoVals.setShowMyShiftModal((x) => {
                    return {};
                  });
                }}
              >
                Close
              </div>

              {sureCancelTil ? (
                <div
                  className="addAbsenceModalUnderlay"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSureCancelChange(false);
                  }}
                >
                  <div className="formCreatedModal">
                    <p className="overlapsRenTxt">
                      Are you sure you want to cancel your TOIL request?
                    </p>
                    <div className="areYouModalBtnsDiv">
                      <p
                        className="areYouSureModalYesBtn"
                        onClick={() => {
                          if (
                            state.tilRequested ||
                            state.tilApproved ||
                            state.tilDeclined
                          ) {
                            setSureCancelTil(false);

                            axios
                              .post(
                                `${serverURL}/remove-til-request`,
                                {
                                  takeTilID: state.takeTilID,
                                  type: state.itemType,
                                  shiftID: state.itemID,
                                  user: true,
                                  nowDs: dateStringer.createStringFromTimestamp(
                                    new Date().getTime()
                                  ),
                                },

                                {
                                  withCredentials: true,
                                  credentials: "include",
                                }
                              )
                              .then((response) => {
                                if (response.data.message === "success") {
                                  // TODO
                                  setState({
                                    tilMins: 0,
                                    tilApproved: false,
                                    tilDeclined: false,
                                    tilRequested: false,
                                    takeTilRequest: false,
                                    takeTilRequestMade: false,
                                  });
                                  memoVals.setShowTilTrimModal((x) => false);
                                  memoVals.setUpdateShifts(
                                    (x) => !memoVals.updateShifts
                                  );
                                } else {
                                }
                              })
                              .catch((err) => {
                                console.error(err);
                              });
                          }
                        }}
                      >
                        Yes
                      </p>
                      <p
                        className="areYouModalNoBtn"
                        onClick={() => {
                          setSureCancelTil(false);
                        }}
                      >
                        Cancel
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
            {/* end of footer */}
          </div>
        )}

        {sureCancelAbsence ? (
          <div
            className="addAbsenceModalUnderlay"
            onClick={(e) => {
              e.stopPropagation();
              setSureCancelAbsence(false);
            }}
          >
            <div className="formCreatedModal">
              <p className="overlapsRenTxt">
                Are you sure you want to cancel your absence submission?
              </p>
              <div className="areYouModalBtnsDiv">
                <p
                  className="areYouSureModalYesBtn"
                  onClick={() => {
                    setSureCancelAbsence(false);
                    axios
                      .post(
                        `${serverURL}/self-log-absence`,
                        {
                          shiftID: state.itemID,
                          type: state.itemType,
                          reason,
                          nowDs: dateStringer.createStringFromTimestamp(
                            new Date().getTime()
                          ),
                          remove: true,
                        },

                        {
                          withCredentials: true,
                          credentials: "include",
                        }
                      )
                      .then((response) => {
                        if (response.data.message === "success") {
                          setState({
                            selfLoggedAbsence: "",
                          });
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  }}
                >
                  Yes
                </p>
                <p
                  className="areYouModalNoBtn"
                  onClick={() => {
                    setSureCancelAbsence(false);
                  }}
                >
                  No
                </p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {renderEditMyShiftModal()}
        {renderTilTrimModal()}
        {sureCancelChange.show ? (
          <div
            className="areYouSureModalUnderlay"
            onClick={() => {
              setSureCancelChange({ show: false });
            }}
          >
            <div
              className="formCreatedModal"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <p className="overlapsRenTxt">
                Are you sure you want to cancel this change?
              </p>
              <div className="areYouModalBtnsDiv">
                <p
                  className="areYouSureModalYesBtn"
                  onClick={() => {
                    setSureCancelChange({ show: false });
                    axios
                      .post(
                        `${serverURL}/cancel-shift-change-request`,
                        {
                          change: sureCancelChange.change,
                          correspondingEditID:
                            sureCancelChange.correspondingEditID,
                          shiftID: sureCancelChange.shiftID,
                        },
                        {
                          withCredentials: true,
                          credentials: "include",
                        }
                      )
                      .then((response) => {
                        if (response.data.message === "success") {
                          // HEIDI

                          memoVals.setUpdateShifts(
                            (x) => !memoVals.updateShifts
                          );
                          memoVals.setUpdateTilData(!memoVals.updateTilData);
                          memoVals.setIndicate((x) => {
                            return {
                              show: true,
                              message: "Change request removed",
                              colour: "green",
                              duration: 4000,
                            };
                          });
                          memoVals.setRemoveMyChangeEditID(
                            (x) => sureCancelChange.editID
                          );
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                      });
                  }}
                >
                  Yes
                </p>
                <p
                  className="areYouModalNoBtn"
                  onClick={() => {
                    setSureCancelChange({ show: false });
                  }}
                >
                  No
                </p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {showSelfLogAbsenceModal ? (
          <div
            className="clockOnModalUnderlay"
            onClick={(e) => {
              e.stopPropagation();
              setShowSelfLogAbsenceModal(false);
            }}
          >
            <div
              className={`dayCommentsModal ${
                memoVals.mobModal ? "mobModalShoulder" : "maxViewZoneModalWidth"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
              style={modalPositionLogAbs}
              ref={modalRefLogAbs}
            >
              {memoVals.mobModal && (
                <div className="modalSwiper modalSwiperLogAbs"></div>
              )}
              <div
                className="mySwapsHeader"
                onClick={() => {
                  setShowSelfLogAbsenceModal(false);
                }}
                onTouchStart={handleDownLogAbs}
                onTouchMove={memoVals.mobModal ? handleMoveLogAbs : null}
                onTouchEnd={memoVals.mobModal ? handleUpLogAbs : null}
                onMouseDown={memoVals.mobModal ? handleDownLogAbs : null}
                onMouseMove={memoVals.mobModal ? handleMoveLogAbs : null}
                onMouseUp={memoVals.mobModal ? handleUpLogAbs : null}
              >
                <img
                  src={close}
                  alt="Close"
                  className="closeMySwapsModalImg"
                  onClick={() => {
                    setShowSelfLogAbsenceModal(false);
                  }}
                />
                <p>Log your absence</p>

                <p></p>
              </div>
              <div className="dayCommentsModalBody">
                <div className="gpsZoneRow noBorder">
                  <p className="lonLatTitles">
                    Absent {state.itemType === "til" ? "TOIL" : state.itemType}
                  </p>

                  <p className={`lonLatVal`}>
                    {dateStringer.printedDateWithTimeFromDs(state.itemDs)}
                  </p>
                </div>
                <div className="gpsZoneRow">
                  <p className="lonLatTitles">Absence duration</p>

                  <p className={`lonLatVal`}>
                    {dateStringer.formatMinsDurationToHours(state.itemDuration)}
                  </p>
                </div>
                <div className="gpsZoneRow">
                  <p className="lonLatTitles">Reason for your absence</p>

                  <div className={`lonLatInputDiv`}>
                    {" "}
                    <textarea
                      type="text"
                      placeholder={`State why you are going to be absent for this ${
                        state.itemType === "til" ? "TOIL" : state.itemType
                      }`}
                      className={`latLonInput x13456783212`}
                      value={reason}
                      onChange={(e) => {
                        // setNewName(e.target.value);
                        setReason(e.target.value);
                      }}
                    ></textarea>
                    <p></p>
                  </div>
                </div>{" "}
              </div>
              <div className="dayCommentsModalFooter">
                <div className="viewMapsAndSaveDiv">
                  <a
                    className="viewGpsZoneMapBtn x4978284432"
                    onClick={() => {
                      setShowSelfLogAbsenceModal(false);

                      axios
                        .post(
                          `${serverURL}/self-log-absence`,
                          {
                            shiftID: state.itemID,
                            type: state.itemType,
                            reason,
                            nowDs: dateStringer.createStringFromTimestamp(
                              new Date().getTime()
                            ),
                          },

                          {
                            withCredentials: true,
                            credentials: "include",
                          }
                        )
                        .then((response) => {
                          if (response.data.message === "success") {
                            setState({
                              selfLoggedAbsence:
                                dateStringer.createStringFromTimestamp(
                                  new Date().getTime()
                                ),
                              selfLoggedAbsenceReason: reason,
                            });
                            setShowSelfLogAbsenceModal(false);
                          }
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    }}
                  >
                    Submit
                  </a>
                </div>

                <p
                  className="closeSeeUserIDBtn"
                  onClick={() => {
                    setShowSelfLogAbsenceModal(false);
                  }}
                >
                  Close
                </p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {showDecline ? (
          <div
            className="clockOnModalUnderlay"
            onClick={(e) => {
              e.stopPropagation();
              setShowDecline(false);
            }}
          >
            <div
              style={modalPositionDecline}
              ref={modalRefDecline}
              className={`dayCommentsModal ${
                memoVals.mobModal ? "mobModalShoulder" : "maxViewZoneModalWidth"
              }`}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {memoVals.mobModal && (
                <div className="modalSwiper modalSwiperDecline"></div>
              )}
              <div
                className="mySwapsHeader"
                onTouchStart={handleDownDecline}
                onTouchMove={memoVals.mobModal ? handleMoveDecline : null}
                onTouchEnd={memoVals.mobModal ? handleUpDecline : null}
                onMouseDown={memoVals.mobModal ? handleDownDecline : null}
                onMouseMove={memoVals.mobModal ? handleMoveDecline : null}
                onMouseUp={memoVals.mobModal ? handleUpDecline : null}
              >
                <img
                  src={close}
                  alt="Close"
                  className="closeMySwapsModalImg"
                  onClick={() => {
                    setShowDecline(false);
                  }}
                />
                <p>
                  Decline this{" "}
                  {state.itemType === "til" ? "TOIL" : state.itemType}
                </p>

                <p></p>
              </div>
              <div className="dayCommentsModalBody">
                <div className="gpsZoneRow noBorder">
                  <p className="lonLatTitles">
                    {state.itemType === "til" ? "TOIL" : state.itemType} date
                  </p>

                  <p className={`lonLatVal`}>
                    {dateStringer.printedDateWithTimeFromDs(state.itemDs)}
                  </p>
                </div>
                <div className="gpsZoneRow">
                  <p className="lonLatTitles">Duration</p>

                  <p className={`lonLatVal`}>
                    {dateStringer.formatMinsDurationToHours(state.itemDuration)}
                  </p>
                </div>
                <div className="gpsZoneRow">
                  <p className="lonLatTitles">Reason for declining</p>

                  <div className={`lonLatInputDiv`}>
                    {" "}
                    <textarea
                      type="text"
                      placeholder={`Optional - state why you are declining this ${
                        state.itemType === "til" ? "TOIL" : state.itemType
                      }`}
                      className={`latLonInput x13456783212`}
                      value={declineReason}
                      onChange={(e) => {
                        setDeclineReason(e.target.value);
                      }}
                    ></textarea>
                    <p></p>
                  </div>
                </div>{" "}
              </div>
              <div className="dayCommentsModalFooter">
                <div className="viewMapsAndSaveDiv">
                  <a
                    className="viewGpsZoneMapBtn x4978284432"
                    onClick={() => {
                      axios
                        .post(
                          `${serverURL}/decline-shift`,
                          {
                            shiftID: state.itemID,
                            type: state.itemType,
                            nowDs: dateStringer.createStringFromTimestamp(
                              new Date().getTime()
                            ),
                            reason: declineReason,
                          },

                          {
                            withCredentials: true,
                            credentials: "include",
                          }
                        )
                        .then((response) => {
                          if (response.data.message === "success") {
                            memoVals.setDeclinedShiftID((x) => state.itemID);
                            memoVals.setIndicate((x) => {
                              return {
                                show: true,
                                message: `Declined this ${
                                  state.itemType === "til"
                                    ? "TOIL"
                                    : state.itemType
                                }`,
                                colour: "blue",
                                duration: 4000,
                              };
                            });
                            setShowDecline(false);
                            memoVals.setShowMyShiftModal((x) => {
                              return {};
                            });
                          }
                        })
                        .catch((err) => {
                          console.error(err);
                        });
                    }}
                  >
                    Decline
                  </a>
                </div>

                <p
                  className="closeSeeUserIDBtn"
                  onClick={() => {
                    setShowDecline(false);
                  }}
                >
                  Close
                </p>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {shiftDoesNotExist ? (
          <div
            className="addAbsenceModalUnderlay"
            onClick={(e) => {
              e.stopPropagation();
              memoVals.setUpdateMyRota((x) => !memoVals.udpateMyRota);
              memoVals.setShowMyShiftModal((x) => false);
            }}
          >
            <div
              className="formCreatedModal"
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              This shift no longer exists.
              <div className="areYouModalBtnsDiv">
                <p
                  className="closeSwapsNoLongerBtn"
                  onClick={() => {
                    memoVals.setUpdateMyRota((x) => !memoVals.udpateMyRota);

                    memoVals.setShowMyShiftModal((x) => false);
                  }}
                >
                  Close
                </p>
                {/* <p
                    className="areYouModalNoBtn"
                    onClick={() => {
                      setNotEnoughModal(false);
                    }}
                  >
                    Cancel
                  </p> */}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        {imgPreload}
      </div>
    );
  } else {
    return "";
  }
};

export default MyShiftModal;
